import {
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
  Switch,
  Tooltip
} from 'antd';
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { AdminProxySpeedTestModal } from '../components/AdminProxySpeedTestModal';
import { AdminSpeedMeasureProgressBar } from '../components/AdminSpeedMeasureProgressBar';
import ProxyStatsPanel from '../components/proxy-stats-panel/ProxyStatsPanel';
import { useBackdropClose } from '../hooks/useBackdropClose';
import { apiService } from '../services/api';
import { readAdminCheckerQueue, clearAdminCheckerQueue, writeAdminCheckerQueue, ensureAdminCheckerQueueLoaded, subscribeAdminCheckerQueue, flushAdminCheckerQueueNow } from '../constants/adminCheckerQueue';
import {
  getAdminCheckerMassSpeedSnapshot,
  startAdminCheckerMassSpeed,
  subscribeAdminCheckerMassSpeed,
} from '../utils/adminCheckerMassSpeedSession';
import { buildAdminCheckerLineFromParsed, parseProxyCheckerDraft } from '../utils/parseProxyCheckerDraft';
import { resolveProxyCheckerSupplierLabel, PROXY_CHECKER_OWN_SUPPLIER_LABEL } from '../utils/proxyCheckerSupplier';
import { buildForSaleStats } from '../utils/for-sale-stats';
import { parseMskInstant } from '../utils/moscow-calendar-date';
import { translateModemRebootReason } from '../utils/modemRebootUtils';
import {
  buildPortsWithModemStatus,
  extractModemsStatusList,
  mergeModemStatsForPanel,
  parseStatsPayloadFromApi,
} from '../utils/modem-stats-from-ports';
import '../styles/proxy-checker.css';
import '../styles/cabinet-proxy-table-shell.css';

/* ============ SVG ICONS ============ */
const RefreshIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_pck_refresh)">
      <path d="M6.0001 0.999894C6.66336 1.00207 7.31959 1.13576 7.93084 1.39324C8.54208 1.65071 9.09619 2.02685 9.5611 2.49989H8.0001C7.86749 2.49989 7.74032 2.55257 7.64655 2.64634C7.55278 2.74011 7.5001 2.86729 7.5001 2.99989C7.5001 3.1325 7.55278 3.25968 7.64655 3.35345C7.74032 3.44722 7.86749 3.49989 8.0001 3.49989H10.0716C10.3178 3.49976 10.5539 3.4019 10.728 3.2278C10.9021 3.0537 11 2.81761 11.0001 2.57139V0.499894C11.0001 0.367286 10.9474 0.240109 10.8537 0.14634C10.7599 0.0525723 10.6327 -0.000106158 10.5001 -0.000106158C10.3675 -0.000106158 10.2403 0.0525723 10.1465 0.14634C10.0528 0.240109 10.0001 0.367286 10.0001 0.499894V1.53889C9.17369 0.79462 8.15639 0.295099 7.06215 0.0962684C5.96791 -0.102562 4.83991 0.00714982 3.80449 0.413118C2.76907 0.819085 1.86711 1.50528 1.19961 2.39486C0.532105 3.28443 0.125422 4.34227 0.0251013 5.44989C0.0186429 5.51952 0.0267591 5.58973 0.0489327 5.65605C0.0711063 5.72237 0.106851 5.78334 0.153889 5.83509C0.200928 5.88683 0.258228 5.92821 0.32214 5.95658C0.386052 5.98496 0.455174 5.99971 0.525101 5.99989C0.647395 6.00145 0.765868 5.95731 0.857331 5.87612C0.948793 5.79492 1.00666 5.68251 1.0196 5.56089C1.13091 4.31627 1.70359 3.15825 2.62514 2.31431C3.54669 1.47038 4.75051 1.00154 6.0001 0.999894Z" fill="currentColor"/>
      <path d="M11.4756 6.00004C11.3533 5.99848 11.2349 6.04262 11.1434 6.12382C11.0519 6.20501 10.9941 6.31742 10.9811 6.43904C10.8985 7.39066 10.5446 8.2986 9.96145 9.05515C9.37831 9.8117 8.5904 10.3851 7.6912 10.7073C6.79199 11.0296 5.81922 11.0871 4.8883 10.8731C3.95738 10.6591 3.10737 10.1826 2.43912 9.50005H4.00012C4.13273 9.50005 4.25991 9.44737 4.35368 9.3536C4.44744 9.25983 4.50012 9.13266 4.50012 9.00005C4.50012 8.86744 4.44744 8.74026 4.35368 8.64649C4.25991 8.55272 4.13273 8.50005 4.00012 8.50005H1.92862C1.80667 8.49998 1.6859 8.52395 1.57322 8.57059C1.46054 8.61723 1.35816 8.68562 1.27193 8.77185C1.18569 8.85808 1.1173 8.96047 1.07067 9.07315C1.02403 9.18583 1.00006 9.3066 1.00012 9.42855V11.5001C1.00012 11.6327 1.0528 11.7598 1.14657 11.8536C1.24034 11.9474 1.36751 12.0001 1.50012 12.0001C1.63273 12.0001 1.75991 11.9474 1.85368 11.8536C1.94744 11.7598 2.00012 11.6327 2.00012 11.5001V10.4611C2.82654 11.2053 3.84383 11.7048 4.93807 11.9037C6.03232 12.1025 7.16031 11.9928 8.19573 11.5868C9.23115 11.1809 10.1331 10.4947 10.8006 9.60509C11.4681 8.71551 11.8748 7.65767 11.9751 6.55004C11.9816 6.48041 11.9735 6.4102 11.9513 6.34388C11.9291 6.27756 11.8934 6.21659 11.8463 6.16485C11.7993 6.11311 11.742 6.07173 11.6781 6.04335C11.6142 6.01498 11.545 6.00023 11.4751 6.00004H11.4756Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_pck_refresh">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const GridIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="4.5" height="4.5" rx="1" stroke="currentColor" strokeWidth="1"/>
    <rect x="7" y="0.5" width="4.5" height="4.5" rx="1" stroke="currentColor" strokeWidth="1"/>
    <rect x="0.5" y="7" width="4.5" height="4.5" rx="1" stroke="currentColor" strokeWidth="1"/>
    <rect x="7" y="7" width="4.5" height="4.5" rx="1" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

const PlusIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 5.5H6.5V0.5C6.5 0.367 6.447 0.24 6.354 0.146C6.26 0.053 6.133 0 6 0C5.867 0 5.74 0.053 5.646 0.146C5.553 0.24 5.5 0.367 5.5 0.5V5.5H0.5C0.367 5.5 0.24 5.553 0.146 5.646C0.053 5.74 0 5.867 0 6C0 6.133 0.053 6.26 0.146 6.354C0.24 6.447 0.367 6.5 0.5 6.5H5.5V11.5C5.5 11.633 5.553 11.76 5.646 11.854C5.74 11.947 5.867 12 6 12C6.133 12 6.26 11.947 6.354 11.854C6.447 11.76 6.5 11.633 6.5 11.5V6.5H11.5C11.633 6.5 11.76 6.447 11.854 6.354C11.947 6.26 12 6.133 12 6C12 5.867 11.947 5.74 11.854 5.646C11.76 5.553 11.633 5.5 11.5 5.5Z" fill="currentColor"/>
  </svg>
);

const RecycleIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#pck-recycle-clip)">
      <path d="M11 3.5C11.2652 3.5 11.5196 3.39464 11.7071 3.20711C11.8946 3.01957 12 2.76522 12 2.5V0.5C12 0.367392 11.9473 0.240215 11.8536 0.146447C11.7598 0.0526784 11.6326 0 11.5 0C11.3674 0 11.2402 0.0526784 11.1464 0.146447C11.0527 0.240215 11 0.367392 11 0.5V2.5H9C8.991 2.5 8.984 2.5045 8.975 2.505C8.73585 1.9125 8.32509 1.40499 7.79545 1.04761C7.2658 0.690226 6.64144 0.499281 6.0025 0.499281C5.36356 0.499281 4.7392 0.690226 4.20955 1.04761C3.67991 1.40499 3.26915 1.9125 3.03 2.505C3.0195 2.5055 3.0105 2.5 3 2.5H1V0.5C1 0.367392 0.947322 0.240215 0.853553 0.146447C0.759785 0.0526784 0.632608 0 0.5 0C0.367392 0 0.240215 0.0526784 0.146447 0.146447C0.0526784 0.240215 0 0.367392 0 0.5L0 2.5C0 2.76522 0.105357 3.01957 0.292893 3.20711C0.48043 3.39464 0.734784 3.5 1 3.5H2.7425L2.236 5.5H0.5C0.367392 5.5 0.240215 5.55268 0.146447 5.64645C0.0526784 5.74021 0 5.86739 0 6C0 6.13261 0.0526784 6.25979 0.146447 6.35355C0.240215 6.44732 0.367392 6.5 0.5 6.5H1.9825L1.91 6.7865L1.9 6.85C1.87771 7.02111 1.86602 7.19344 1.865 7.366C1.86551 7.74969 1.91987 8.13142 2.0265 8.5H1C0.734784 8.5 0.48043 8.60536 0.292893 8.79289C0.105357 8.98043 0 9.23478 0 9.5L0 11.5C0 11.6326 0.0526784 11.7598 0.146447 11.8536C0.240215 11.9473 0.367392 12 0.5 12C0.632608 12 0.759785 11.9473 0.853553 11.8536C0.947322 11.7598 1 11.6326 1 11.5V9.5H2.465C2.83155 10.1101 3.34976 10.6149 3.96921 10.9654C4.58866 11.3159 5.28827 11.5001 6 11.5001C6.71173 11.5001 7.41134 11.3159 8.03079 10.9654C8.65024 10.6149 9.16845 10.1101 9.535 9.5H11V11.5C11 11.6326 11.0527 11.7598 11.1464 11.8536C11.2402 11.9473 11.3674 12 11.5 12C11.6326 12 11.7598 11.9473 11.8536 11.8536C11.9473 11.7598 12 11.6326 12 11.5V9.5C12 9.23478 11.8946 8.98043 11.7071 8.79289C11.5196 8.60536 11.2652 8.5 11 8.5H9.9735C10.0807 8.13066 10.1354 7.74808 10.136 7.3635C10.1345 7.19176 10.1225 7.02027 10.1 6.85L10.0125 6.5H11.5C11.6326 6.5 11.7598 6.44732 11.8536 6.35355C11.9473 6.25979 12 6.13261 12 6C12 5.86739 11.9473 5.74021 11.8536 5.64645C11.7598 5.55268 11.6326 5.5 11.5 5.5H9.761L9.2565 3.5H11ZM6 10.5C5.16848 10.4991 4.37129 10.1683 3.78336 9.58029C3.19543 8.99227 2.86479 8.19502 2.864 7.3635C2.86469 7.24198 2.87253 7.1206 2.8875 7L3.9025 2.985C4.05483 2.55255 4.33709 2.17775 4.71065 1.91191C5.0842 1.64606 5.53079 1.50217 5.98928 1.49992C6.44777 1.49768 6.89575 1.63719 7.27189 1.89937C7.64803 2.16154 7.93394 2.53356 8.0905 2.9645L9.1125 7C9.12743 7.12027 9.13527 7.24131 9.136 7.3625C9.13547 8.19419 8.80495 8.9917 8.21699 9.57993C7.62904 10.1682 6.83169 10.4991 6 10.5Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="pck-recycle-clip">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const CaretDownIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.61 6L8 10.06L11.39 6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CaretUpIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.39 10.06L8 6L4.61 10.06" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const FilterOffIcon = () => (
  <svg className="pck-header__btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 4H15.5L9 13V19L7 17V13L3 7.58V4Z" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 8L22 13" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M22 8L17 13" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

const FilterIcon = ({ active = false }) => (
  <svg
    className={`pck-th-filter-icon${active ? ' pck-th-filter-icon--active' : ''}`}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00005 14C8.89187 14 8.7866 13.9649 8.70005 13.9L6.70005 12.4C6.63795 12.3534 6.58755 12.293 6.55284 12.2236C6.51812 12.1542 6.50005 12.0776 6.50005 12V9.19L2.99205 5.2435C2.74291 4.96244 2.58024 4.61541 2.52359 4.24412C2.46694 3.87283 2.51872 3.49308 2.67271 3.15051C2.8267 2.80794 3.07635 2.51713 3.39164 2.31303C3.70694 2.10894 4.07446 2.00024 4.45005 2H11.5501C11.9256 2.00044 12.293 2.10932 12.6082 2.31355C12.9234 2.51779 13.1729 2.80869 13.3267 3.15129C13.4805 3.4939 13.5321 3.87364 13.4753 4.24487C13.4185 4.61611 13.2558 4.96305 13.0066 5.244L9.50005 9.19V13.5C9.50005 13.6326 9.44737 13.7598 9.3536 13.8536C9.25984 13.9473 9.13266 14 9.00005 14ZM7.50005 11.75L8.50005 12.5V9C8.50015 8.87758 8.54516 8.75945 8.62655 8.668L12.2606 4.5795C12.3817 4.44254 12.4608 4.27352 12.4883 4.09273C12.5157 3.91193 12.4905 3.72705 12.4154 3.56028C12.3404 3.39351 12.2189 3.25193 12.0654 3.15254C11.9118 3.05316 11.7329 3.00019 11.5501 3H4.45005C4.26728 3.00028 4.08846 3.05327 3.93505 3.15263C3.78164 3.25199 3.66015 3.3935 3.58516 3.56018C3.51016 3.72685 3.48483 3.91163 3.51221 4.09234C3.5396 4.27305 3.61854 4.44203 3.73955 4.579L7.37405 8.668C7.45526 8.75952 7.50009 8.87764 7.50005 9V11.75Z"
      fill="currentColor" stroke="currentColor" strokeWidth="0.6"
    />
  </svg>
);

const ChevronFirstIcon = () => (
  <svg className="pck-pagination__btn-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.78 3.33L2 8L6.78 12.67" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.78 3.33L8 8L12.78 12.67" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ChevronLeftIcon = () => (
  <svg className="pck-pagination__btn-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.54 3.33L5.76 8L10.54 12.67" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ChevronRightIcon = () => (
  <svg className="pck-pagination__btn-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.46 3.33L10.24 8L5.46 12.67" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ChevronLastIcon = () => (
  <svg className="pck-pagination__btn-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.22 3.33L8 8L3.22 12.67" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.22 3.33L14 8L9.22 12.67" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PaginationChevronDown = () => (
  <svg className="pck-pagination__select-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PER_PAGE_OPTIONS = [10, 15, 20, 50, 100];

const PerPageDropdown = ({ value, options, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => setOpen((prev) => !prev);

  const handleSelect = (opt) => {
    onChange(opt);
    setOpen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setOpen(false);
    }
  };

  return (
    <div className="pck-pagination__per-page" ref={ref} onKeyDown={handleKeyDown}>
      <button
        type="button"
        className="pck-pagination__select"
        onClick={handleToggle}
        aria-label={`${value} на странице`}
        aria-expanded={open}
        tabIndex={0}
      >
        <span className="pck-pagination__select-value">{value}</span>
        <span className="pck-pagination__select-text"> на странице</span>
        <PaginationChevronDown />
      </button>
      {open && (
        <div className="pck-pagination__dropdown" role="listbox">
          {options.map((opt) => (
            <button
              key={opt}
              type="button"
              role="option"
              aria-selected={opt === value}
              className={`pck-pagination__option${opt === value ? ' pck-pagination__option--active' : ''}`}
              onClick={() => handleSelect(opt)}
              tabIndex={0}
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};


const StatusDotHeader = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="4" fill="url(#statusDotGradient)"/>
    <defs>
      <linearGradient id="statusDotGradient" x1="8" y1="3.972" x2="0" y2="4.028" gradientUnits="userSpaceOnUse">
        <stop offset="0.5" stopColor="#F33F4E"/>
        <stop offset="0.5" stopColor="#0CBE90"/>
      </linearGradient>
    </defs>
  </svg>
);

/* ============ RULES ACTION MENU ============ */
const RulesActionMenu = ({ rule, onEdit, onToggle, onDelete }) => {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const menuRef = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (
        btnRef.current && !btnRef.current.contains(e.target) &&
        menuRef.current && !menuRef.current.contains(e.target)
      ) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const handleToggle = () => {
    if (!open && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 4, left: rect.right });
    }
    setOpen(v => !v);
  };

  return (
    <div className="pck-rules-action">
      <button
        ref={btnRef}
        type="button"
        className="pm-action-dots"
        onClick={handleToggle}
        aria-label="Действия"
        tabIndex={0}
      >
        <span className="pm-action-dots__dot" />
        <span className="pm-action-dots__dot" />
        <span className="pm-action-dots__dot" />
      </button>
      {open && ReactDOM.createPortal(
        <div
          ref={menuRef}
          className="pm-action-dropdown--portal"
          style={{ top: pos.top, left: pos.left }}
        >
          <button
            type="button"
            className="pm-action-dropdown--portal__item"
            onClick={() => { setOpen(false); onEdit(rule); }}
          >
            Редактировать
          </button>
          <button
            type="button"
            className="pm-action-dropdown--portal__item"
            onClick={() => { setOpen(false); onToggle(rule); }}
          >
            {rule.is_active ? 'Отключить' : 'Активировать'}
          </button>
          <div className="pm-action-dropdown--portal__divider" />
          <button
            type="button"
            className="pm-action-dropdown--portal__item pm-action-dropdown--portal__item--danger"
            onClick={() => { setOpen(false); onDelete(rule); }}
          >
            Удалить
          </button>
        </div>,
        document.body
      )}
    </div>
  );
};

/* ============ FILTER DROPDOWN ============ */
const PckFilterDropdown = ({ column, values, activeFilters, onApply, onReset, onClose, anchorRef }) => {
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(new Set(activeFilters || []));
  const ref = useRef(null);
  const searchInputRef = useRef(null);
  const [pos, setPos] = useState(null);

  useLayoutEffect(() => {
    setSelected(new Set(activeFilters || []));
  }, [activeFilters, column]);

  useLayoutEffect(() => {
    if (!anchorRef?.current) {
      setPos(null);
      return;
    }
    const margin = 8;
    const recalc = () => {
      const el = anchorRef.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      const dropW = 254;
      let left = r.left;
      if (left + dropW > window.innerWidth) left = window.innerWidth - dropW - margin;
      if (left < margin) left = margin;

      // Строго под кнопкой; высота панели — только до низа экрана, список прокручивается внутри (flex).
      const top = r.bottom + 4;
      const spaceBelow = Math.max(0, window.innerHeight - margin - top);
      setPos({ top, left, panelMaxHeight: spaceBelow });
    };
    recalc();
    const rafId = requestAnimationFrame(recalc);
    return () => cancelAnimationFrame(rafId);
  }, [anchorRef, column, values, search]);

  useLayoutEffect(() => {
    if (!pos) return;
    const id = requestAnimationFrame(() => {
      try {
        searchInputRef.current?.focus({ preventScroll: true });
      } catch {
        searchInputRef.current?.focus();
      }
    });
    return () => cancelAnimationFrame(id);
  }, [pos]);

  useEffect(() => {
    const handler = (e) => {
      // Клик по кнопке-якорю не закрывает панель — закрытие/повторное открытие делает onClick на кнопке (toggle).
      if (anchorRef?.current?.contains(e.target)) return;
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose, anchorRef]);

  const filtered = values.filter((v) => String(v).toLowerCase().includes(search.toLowerCase()));

  const handleToggle = (val) => {
    const next = new Set(selected);
    if (next.has(val)) next.delete(val); else next.add(val);
    setSelected(next);
  };

  const dropdown = (
    <div
      className="pck-filter-dropdown pck-filter-dropdown--portal"
      ref={ref}
      style={
        pos
          ? {
              position: 'fixed',
              top: pos.top,
              left: pos.left,
              zIndex: 9999,
              maxHeight: pos.panelMaxHeight,
              display: 'flex',
              flexDirection: 'column',
              boxSizing: 'border-box',
            }
          : undefined
      }
    >
      <div className="pck-filter-dropdown__header">Фильтр</div>
      <div className="pck-filter-dropdown__search">
        <input
          ref={searchInputRef}
          placeholder="Поиск..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="pck-filter-dropdown__list pck-filter-dropdown__list--portal-scroll">
        {filtered.length === 0 && <div className="pck-filter-dropdown__empty">Ничего не найдено</div>}
        {filtered.map((val) => (
          <label className="pck-filter-dropdown__item" key={val}>
            <input type="checkbox" checked={selected.has(val)} onChange={() => handleToggle(val)} />
            <span>{val}</span>
          </label>
        ))}
      </div>
      <div className="pck-filter-dropdown__actions">
        <button type="button" className="pck-filter-dropdown__btn pck-filter-dropdown__btn--reset" onClick={() => { setSelected(new Set()); onReset(column); onClose(); }}>Сбросить</button>
        <button type="button" className="pck-filter-dropdown__btn pck-filter-dropdown__btn--apply" onClick={() => { onApply(column, Array.from(selected)); onClose(); }}>Применить</button>
      </div>
    </div>
  );

  if (!pos) {
    return null;
  }

  return ReactDOM.createPortal(dropdown, document.body);
};

/* ============ FILTER BUTTON WITH REF ============ */
const PckFilterBtn = ({ colKey, label, hasFilter, isOpen, onToggle, values, activeFilters, onApply, onReset, onClose }) => {
  const btnRef = useRef(null);
  return (
    <div className="pck-th-filter-wrap">
      <button
        ref={btnRef}
        type="button"
        className={`pck-th-filter ${hasFilter ? 'pck-th-filter--active' : ''}`}
        onMouseDown={(e) => {
          e.preventDefault();
        }}
        onClick={onToggle}
        aria-label={`Фильтр по ${label}`}
        tabIndex={0}
      >
        <FilterIcon active={hasFilter} />
      </button>
      {isOpen && (
        <PckFilterDropdown
          column={colKey}
          values={values}
          activeFilters={activeFilters}
          onApply={onApply}
          onReset={onReset}
          onClose={onClose}
          anchorRef={btnRef}
        />
      )}
    </div>
  );
};

/* ============ COLUMN CONFIG ============ */
const COLUMNS = [
  { key: 'id',          label: 'ID',             cssClass: 'pck-col--id',         sortable: true,  filterable: false },
  { key: 'initiated_at',label: 'Время',          cssClass: 'pck-col--time',       sortable: true,  filterable: false },
  { key: 'client_login',label: 'Клиент',         cssClass: 'pck-col--client',     sortable: true,  filterable: true },
  { key: 'tariff',      label: 'Тариф',          cssClass: 'pck-col--tariff',     sortable: true,  filterable: true },
  { key: 'city',        label: 'Город',          cssClass: 'pck-col--city',       sortable: true,  filterable: true },
  { key: 'server',      label: 'Сервер',         cssClass: 'pck-col--server',     sortable: true,  filterable: true },
  { key: 'modem_from',  label: 'Модем\u2192',    cssClass: 'pck-col--modem-from', sortable: true,  filterable: true },
  { key: 'modem_to',    label: '\u2192Модем',     cssClass: 'pck-col--modem-to',   sortable: true,  filterable: true },
  { key: 'port',        label: 'Порт',           cssClass: 'pck-col--port',       sortable: true,  filterable: true },
  { key: 'reason',      label: 'Причина',        cssClass: 'pck-col--reason',     sortable: false, filterable: true },
  { key: 'status',      label: 'Статус замены',  cssClass: 'pck-col--status',     sortable: true,  filterable: true },
  { key: 'error',       label: 'Ошибка',         cssClass: 'pck-col--error',      sortable: false, filterable: false },
];

const REBOOT_LOG_COLUMNS = [
  { key: 'id', label: 'ID', cssClass: 'pck-col--reboot-id', sortable: true, filterable: false },
  { key: 'created_at', label: 'Время', cssClass: 'pck-col--reboot-time', sortable: true, filterable: false },
  { key: 'connection_name', label: 'Сервер', cssClass: 'pck-col--reboot-server', sortable: true, filterable: true },
  { key: 'modem_name', label: 'Модем', cssClass: 'pck-col--reboot-modem', sortable: true, filterable: true },
  { key: 'event_type', label: 'Событие', cssClass: 'pck-col--reboot-event', sortable: true, filterable: true },
  { key: 'stage', label: 'Этап', cssClass: 'pck-col--reboot-stage', sortable: true, filterable: true },
  { key: 'outage_minutes', label: 'Простой, мин', cssClass: 'pck-col--reboot-outage', sortable: true, filterable: false },
  { key: 'status', label: 'Статус', cssClass: 'pck-col--reboot-status', sortable: true, filterable: true },
  { key: 'guard_reason', label: 'Причина/ошибка', cssClass: 'pck-col--reboot-reason', sortable: false, filterable: false },
];

const REBOOT_EVENT_LABELS = {
  guard: 'Блокировка',
  queued: 'Запуск',
  completed: 'Завершение',
};

const REBOOT_STAGE_LABELS = {
  first: '1-й reboot',
  second: '2-й reboot',
  manual: 'Ручной',
  dashboard_bulk: 'Dashboard',
};

/* ============ HELPERS ============ */
const getModemNumber = (ip) => {
  if (!ip) return null;
  const parts = ip.split('.');
  return parts.length === 4 ? parts[2] : null;
};

const formatModemName = (name, ip) => {
  if (!name || name === '-' || name === 'Неизвестен' || name === 'Не найден') return name || '-';
  // Legacy: old logs store "connection / modem", extract modem part
  const cleanName = name.includes(' / ') ? name.split(' / ').pop() : name;
  // Already formatted with №
  if (cleanName.startsWith('№')) return cleanName;
  const num = getModemNumber(ip);
  return num ? `№ ${num} ${cleanName}` : cleanName;
};

const formatDate = (time) => {
  if (!time) return '-';
  try {
    const d = parseMskInstant(time);
    if (!d) return '-';
    const date = d.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'Europe/Moscow'
    });
    const hours = d.toLocaleTimeString('ru-RU', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Moscow'
    });
    return `${date} ${hours}`;
  } catch {
    return '-';
  }
};

/** Дата и время быстрой проверки доступности в очереди чекера (колонка «Проверен»). */
const formatAdminQueueAvailabilityCheckedAtNow = () => {
  const d = new Date();
  try {
    const date = d.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'Europe/Moscow',
    });
    const time = d.toLocaleTimeString('ru-RU', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'Europe/Moscow',
    });
    return `${date} ${time}`;
  } catch {
    return d.toLocaleString('ru-RU');
  }
};

const escapeRegex = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const isUnknownOperator = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  return normalized === '' || ['unknown', 'none', 'null', 'n/a', '-'].includes(normalized);
};

const normalizeOperatorTemplates = (rawTemplates) => {
  if (!Array.isArray(rawTemplates)) return [];
  return rawTemplates
    .filter((item) => item && typeof item === 'object')
    .map((item) => ({
      name: String(item.name || '').trim(),
      patterns: Array.isArray(item.patterns)
        ? item.patterns.map((pattern) => String(pattern || '').trim()).filter(Boolean)
        : [],
    }))
    .filter((item) => item.name);
};

const resolveOperatorByTemplates = (rawOperator, templates) => {
  const value = String(rawOperator || '').trim();
  if (isUnknownOperator(value)) return 'UNKNOWN';
  const preparedTemplates = normalizeOperatorTemplates(templates);
  if (preparedTemplates.length === 0) return value;

  for (const template of preparedTemplates) {
    for (const pattern of template.patterns) {
      try {
        const regex = new RegExp(`^${escapeRegex(pattern).replace(/\\\*/g, '.*')}$`, 'i');
        if (regex.test(value)) return template.name;
      } catch {
        continue;
      }
    }
  }

  return value;
};

const extractPortsArray = (response) => {
  const payload = response?.data;
  if (Array.isArray(payload?.ports)) return payload.ports;
  if (Array.isArray(payload?.data?.ports)) return payload.data.ports;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
};

const normalizeTariffLabel = (tariff) => {
  if (!tariff) return '-';
  const raw = String(tariff).trim();
  if (!raw) return '-';
  return raw.replace(/_\d+$/, '');
};

const getCellValue = (row, key) => {
  switch (key) {
    case 'id':           return row.id ?? '-';
    case 'initiated_at': return formatDate(row.initiated_at);
    case 'client_login': return row.client_login || '-';
    case 'tariff': {
      const rawTariff = row.details?.tariff || row.details?.tariff_plan || '-';
      return normalizeTariffLabel(rawTariff);
    }
    case 'city': {
      const city = row.details?.city || row.details?.selected_city || '-';
      if (city.startsWith('Санкт')) return 'СПб';
      if (city.startsWith('Москв')) return 'МСК';
      return city;
    }
    case 'server':       return row.details?.connection_name || row.details?.connection || row.details?.server || row.details?.server_name || '-';
    case 'modem_from':   return formatModemName(row.original_modem_name, row.original_server_ip);
    case 'modem_to':     return formatModemName(row.replacement_modem_name, row.replacement_server_ip);
    case 'port':         return row.original_port || row.details?.port || '-';
    case 'reason':       return row.replacement_reason || '-';
    case 'status':       return row.status || '-';
    case 'error':        return row.error_message || row.details?.modem_params?.new_modem?.error || row.details?.modem_params?.old_modem?.error || row.details?.modem_params?.error || '-';
    default:             return '-';
  }
};

const getSortValue = (row, key) => {
  switch (key) {
    case 'id':           return row.id ?? 0;
    case 'initiated_at': return row.initiated_at ? new Date(row.initiated_at).getTime() : 0;
    case 'client_login': return (row.client_login || '').toLowerCase();
    case 'tariff': {
      const rawTariff = row.details?.tariff || row.details?.tariff_plan || '';
      return normalizeTariffLabel(rawTariff).toLowerCase();
    }
    case 'city':         return (row.details?.city || row.details?.selected_city || '').toLowerCase();
    case 'server':       return (row.details?.connection_name || row.details?.connection || row.details?.server || '').toLowerCase();
    case 'modem_from':   return formatModemName(row.original_modem_name, row.original_server_ip).toLowerCase();
    case 'modem_to':     return formatModemName(row.replacement_modem_name, row.replacement_server_ip).toLowerCase();
    case 'port':         return Number(row.original_port || row.details?.port) || 0;
    case 'status':       return (row.status || '').toLowerCase();
    default:             return '';
  }
};

const getTariffBadgeClass = (tariff) => {
  if (!tariff || tariff === '-') return '';
  const t = tariff.toLowerCase();
  if (t.includes('общий') && t.includes('+')) return 'pck-badge--dark';
  if (t.includes('общий'))                     return 'pck-badge--grey';
  if (t.includes('индивид'))                   return 'pck-badge--blue';
  return 'pck-badge--grey';
};

const getStatusBadgeClass = (status) => {
  switch (status) {
    case 'completed': return 'pck-badge--green';
    case 'failed':    return 'pck-badge--red';
    case 'executing': return 'pck-badge--blue';
    case 'found':     return 'pck-badge--blue';
    case 'initiated': return 'pck-badge--orange';
    default:          return 'pck-badge--grey';
  }
};

const getRebootCellValue = (row, key) => {
  switch (key) {
    case 'id':
      return row.id ?? '-';
    case 'created_at':
      return formatDate(row.created_at);
    case 'connection_name':
      return row.connection_name || '-';
    case 'modem_name':
      return row.modem_name || '-';
    case 'event_type':
      return REBOOT_EVENT_LABELS[row.event_type] || row.event_type || '-';
    case 'stage':
      return REBOOT_STAGE_LABELS[row.stage] || row.stage || '-';
    case 'outage_minutes':
      return row.outage_minutes != null ? Number(row.outage_minutes).toFixed(1) : '-';
    case 'status':
      return row.status || '-';
    case 'guard_reason': {
      const reason = translateModemRebootReason(row.guard_reason)
        || translateModemRebootReason(row.error_message)
        || row.error_message
        || '-';
      if (reason !== '-' && row.check_rule_name) {
        return `${reason} (${row.check_rule_name})`;
      }
      return reason;
    }
    default:
      return '-';
  }
};

const getRebootSortValue = (row, key) => {
  switch (key) {
    case 'id':
      return row.id ?? 0;
    case 'created_at':
      return row.created_at ? new Date(row.created_at).getTime() : 0;
    case 'connection_name':
      return (row.connection_name || '').toLowerCase();
    case 'modem_name':
      return (row.modem_name || '').toLowerCase();
    case 'event_type':
      return (row.event_type || '').toLowerCase();
    case 'stage':
      return (row.stage || '').toLowerCase();
    case 'outage_minutes':
      return Number(row.outage_minutes) || 0;
    case 'status':
      return (row.status || '').toLowerCase();
    default:
      return '';
  }
};

const getRebootStatusBadgeClass = (status) => {
  switch (status) {
    case 'success':
      return 'pck-badge--green';
    case 'error':
      return 'pck-badge--red';
    case 'in_progress':
      return 'pck-badge--blue';
    case 'skipped':
      return 'pck-badge--orange';
    default:
      return 'pck-badge--grey';
  }
};

const getStatusLabel = (status) => {
  const map = {
    completed: 'Завершено',
    failed: 'Ошибка',
    executing: 'Выполняется',
    found: 'Найден',
    initiated: 'Инициировано',
  };
  return map[status] || status || '-';
};

/* ============ CABINET TABLE SHELL (как в ЛК OrdersPage) ============ */
const CabinetSortChevronIcon = () => (
  <svg className="proxy-checker-table__sort-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M8 11L4 7H12L8 11Z" fill="currentColor" />
  </svg>
);

const CabinetFilterFunnelIcon = () => (
  <svg
    className="proxy-checker-table__filter-icon"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g clipPath="url(#pckCabinetFunnelClip)">
      <path
        d="M6.99999 12C6.89181 12 6.78654 11.9649 6.69999 11.9L4.69999 10.4C4.63789 10.3534 4.58749 10.293 4.55278 10.2236C4.51806 10.1542 4.49999 10.0776 4.49999 10V7.19L0.99199 3.2435C0.74285 2.96244 0.58018 2.61541 0.52353 2.24412C0.466881 1.87283 0.518662 1.49308 0.672652 1.15051C0.826641 0.807938 1.07629 0.517129 1.39158 0.313033C1.70688 0.108936 2.0744 0.000237209 2.44999 0L9.54999 0C9.92555 0.000440525 10.293 0.10932 10.6081 0.313553C10.9233 0.517787 11.1728 0.808686 11.3266 1.15129C11.4805 1.4939 11.5321 1.87364 11.4753 2.24487C11.4185 2.61611 11.2557 2.96305 11.0065 3.244L7.49999 7.19V11.5C7.49999 11.6326 7.44731 11.7598 7.35354 11.8536C7.25978 11.9473 7.1326 12 6.99999 12V12ZM5.49999 9.75L6.49999 10.5V7C6.50009 6.87758 6.5451 6.75945 6.62649 6.668L10.2605 2.5795C10.3817 2.44254 10.4607 2.27352 10.4882 2.09273C10.5157 1.91193 10.4904 1.72705 10.4154 1.56028C10.3404 1.39351 10.2188 1.25193 10.0653 1.15254C9.91179 1.05316 9.73286 1.00019 9.54999 1H2.44999C2.26722 1.00028 2.0884 1.05327 1.93499 1.15263C1.78158 1.25199 1.66009 1.3935 1.58509 1.56018C1.51009 1.72685 1.48477 1.91163 1.51215 2.09234C1.53954 2.27305 1.61847 2.44203 1.73949 2.579L5.37399 6.668C5.4552 6.75952 5.50003 6.87764 5.49999 7V9.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="pckCabinetFunnelClip">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

/** Фильтр столбца очереди чекера (кабинет): та же выпадашка, что и в логах. */
const CabinetQueueThFilterBtn = ({
  colKey,
  label,
  hasFilter,
  isOpen,
  onToggle,
  values,
  activeFilters,
  onApply,
  onReset,
  onClose,
}) => {
  const btnRef = useRef(null);
  return (
    <div className="proxy-checker-th-filter-wrap">
      <button
        ref={btnRef}
        type="button"
        className={`proxy-checker-menu-btn${hasFilter ? ' proxy-checker-menu-btn--filter-active' : ''}`}
        onMouseDown={(e) => {
          e.preventDefault();
        }}
        onClick={onToggle}
        aria-label={`Фильтр: ${label}`}
        aria-expanded={Boolean(isOpen)}
        tabIndex={0}
      >
        <CabinetFilterFunnelIcon />
      </button>
      {isOpen && (
        <PckFilterDropdown
          column={colKey}
          values={values}
          activeFilters={activeFilters}
          onApply={onApply}
          onReset={onReset}
          onClose={onClose}
          anchorRef={btnRef}
        />
      )}
    </div>
  );
};

const CabinetRowMenuIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="8" cy="3" r="1.5" fill="currentColor" />
    <circle cx="8" cy="8" r="1.5" fill="currentColor" />
    <circle cx="8" cy="13" r="1.5" fill="currentColor" />
  </svg>
);

const CabinetHeaderCheckboxArt = () => (
  <svg
    className="proxy-checker-table__checkbox-svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g clipPath="url(#pckCabinetCbClip)">
      <path
        d="M12.6667 0H3.33333C2.4496 0.00105857 1.60237 0.352588 0.97748 0.97748C0.352588 1.60237 0.00105857 2.4496 0 3.33333L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V3.33333C15.9989 2.4496 15.6474 1.60237 15.0225 0.97748C14.3976 0.352588 13.5504 0.00105857 12.6667 0V0ZM14.6667 12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V3.33333C1.33333 2.8029 1.54405 2.29419 1.91912 1.91912C2.29419 1.54405 2.8029 1.33333 3.33333 1.33333H12.6667C13.1971 1.33333 13.7058 1.54405 14.0809 1.91912C14.456 2.29419 14.6667 2.8029 14.6667 3.33333V12.6667Z"
        fill="#C2C2C2"
      />
    </g>
    <defs>
      <clipPath id="pckCabinetCbClip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

function adminQueueRowKey(row) {
  if (row && row.external_key != null) {
    return `ext-${row.external_key}`;
  }
  return `id-${row.proxy_id}`;
}

function adminQueueBusyKey(row) {
  if (row && row.external_key != null) {
    return row.external_key;
  }
  return row.proxy_id;
}

/** Колонка «Логин»: логин авторизации прокси (не метка «Сторонний», не client_login в приоритете). */
function formatCheckerQueueLoginCell(row) {
  const auth = String(row?.login ?? '').trim();
  if (auth) return auth;
  const prov = String(row?.provider ?? '').trim();
  if (prov && prov !== 'Сторонний') return prov;
  return '—';
}

const CABINET_QUEUE_FILTER_KEYS = [
  'provider',
  'host',
  'port',
  'type',
  'availability',
  'supplier',
  'operator',
];

const CABINET_QUEUE_FILTER_LABELS = {
  provider: 'Логин',
  host: 'Host',
  port: 'Порт',
  type: 'Тип прокси',
  availability: 'Доступность',
  supplier: 'Поставщик',
  operator: 'Оператор',
};

/** Колонки без фильтрации (кнопка-заглушка, как при отключённых фильтрах). */
const CABINET_QUEUE_NO_FILTER_COL_KEYS = new Set(['checked', 'speedMax', 'speedAvg', 'measure']);

/** Оператор для своих (LTE Center); для чужих — прочерк. */
function formatCheckerQueueOperatorCell(row, resolveSupplierLabel, templates) {
  const supplier =
    typeof resolveSupplierLabel === 'function'
      ? resolveSupplierLabel(row)
      : resolveProxyCheckerSupplierLabel(row, [], []);
  if (supplier !== PROXY_CHECKER_OWN_SUPPLIER_LABEL) return '—';
  const raw = row?.selected_operator ?? row?.mobile_operator ?? '';
  if (isUnknownOperator(raw)) return '—';
  const resolved = resolveOperatorByTemplates(raw, templates);
  if (isUnknownOperator(resolved) || resolved === 'UNKNOWN') return '—';
  return resolved;
}

/** Модификатор цвета — как getOperatorBadge в ProxyTable. */
function resolveOperatorBadgeModifier(raw) {
  const v = String(raw ?? '').trim().toLowerCase();
  if (!v || v === '—' || v === '-') return null;
  if (v === 'unknown' || v === 'none' || v === 'null' || v === 'n/a') return 'default';
  if (v.includes('мтс') || v === 'mts') return 'mts';
  if (v.includes('мегафон') || v === 'megafon') return 'megafon';
  if (v.includes('т2') || v.includes('теле2') || v === 'tele2') return 'tele2';
  if (v.includes('билайн') || v === 'beeline') return 'beeline';
  return 'default';
}

function renderCheckerOperatorBadge(label) {
  const trimmed = String(label ?? '').trim();
  if (!trimmed || trimmed === '—') return '—';
  const modifier = resolveOperatorBadgeModifier(trimmed) || 'default';
  return (
    <span className={`proxy-checker-operator-badge proxy-checker-operator-badge--${modifier}`}>
      {trimmed}
    </span>
  );
}

function getCabinetQueueRowFilterSnapshot(row, resolveSupplierLabel, templates) {
  const fn = typeof resolveSupplierLabel === 'function' ? resolveSupplierLabel : () => '—';
  return {
    provider: formatCheckerQueueLoginCell(row),
    host: String(row.host ?? '—').trim() || '—',
    port: String(row.port ?? '—'),
    type: String(row.proxy_type ?? '—'),
    availability: String(row.availability ?? '—').trim() || '—',
    supplier: fn(row),
    operator: formatCheckerQueueOperatorCell(row, resolveSupplierLabel, templates),
  };
}

function buildCabinetQueueFilterOptions(rows, resolveSupplierLabel, templates) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return Object.fromEntries(CABINET_QUEUE_FILTER_KEYS.map((k) => [k, []]));
  }
  const sets = Object.fromEntries(CABINET_QUEUE_FILTER_KEYS.map((k) => [k, new Set()]));
  rows.forEach((row) => {
    const snap = getCabinetQueueRowFilterSnapshot(row, resolveSupplierLabel, templates);
    CABINET_QUEUE_FILTER_KEYS.forEach((k) => {
      sets[k].add(snap[k]);
    });
  });
  return Object.fromEntries(
    CABINET_QUEUE_FILTER_KEYS.map((k) => [
      k,
      [...sets[k]].sort((a, b) => String(a).localeCompare(String(b), 'ru')),
    ])
  );
}

function filterCabinetQueueRowsBySnapshot(rows, filters, resolveSupplierLabel, templates) {
  if (!Array.isArray(rows) || rows.length === 0) return rows;
  if (!filters || typeof filters !== 'object') return rows;
  const allowed = new Set(CABINET_QUEUE_FILTER_KEYS);
  const entries = Object.entries(filters).filter(
    ([key, v]) => allowed.has(key) && Array.isArray(v) && v.length > 0
  );
  if (entries.length === 0) return rows;
  return rows.filter((row) => {
    const snap = getCabinetQueueRowFilterSnapshot(row, resolveSupplierLabel, templates);
    return entries.every(([key, selected]) => selected.includes(snap[key]));
  });
}

function proxyTypeForAdhocApi(row) {
  const t = String(row.proxy_type || 'http').toLowerCase();
  return t.includes('sock') ? 'socks5' : 'http';
}

/** Шаблоны строк прокси в боковой панели чекера (менеджер и тот же блок в ЛК). */
const PROXY_CHECKER_FORMAT_TEMPLATE_LINES = [
  '{protocol}://{login}:{password}@{ip}:{port}',
  '{protocol}://{login}:{password}:{ip}:{port}',
  '{login}:{password}@{ip}:{port}',
  '{login}:{password}:{ip}:{port}',
  '{protocol}://{ip}:{port}@{login}:{password}',
  '{protocol}://{ip}:{port}:{login}:{password}',
  '{ip}:{port}@{login}:{password}',
  '{ip}:{port}:{login}:{password}',
];

const CabinetAutoCheckToggleArt = ({ isOn }) => (
  <svg className="proxy-checker-toggle__svg" width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H18C22.4183 0 26 3.58172 26 8C26 12.4183 22.4183 16 18 16H8C3.58172 16 0 12.4183 0 8Z"
      fill={isOn ? '#ecfef9' : '#FDE2E4'}
    />
    <g transform={isOn ? 'translate(10 0)' : 'translate(0 0)'}>
      <path
        d="M2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8Z"
        fill={isOn ? '#0cbe90' : '#F33F4E'}
      />
    </g>
  </svg>
);

function CabinetProxyCheckerSidePanel({ onAppendCheckerProxies }) {
  const [sourceTab, setSourceTab] = useState('manual');
  const [proxyDraft, setProxyDraft] = useState('');
  const [urlInput, setUrlInput] = useState('');
  const [autoCheckNew, setAutoCheckNew] = useState(false);
  const fileInputRef = useRef(null);
  const toggleLabelId = 'pck-cabinet-autocheck-label';

  const handleAddProxies = () => {
    const parsed = parseProxyCheckerDraft(proxyDraft);
    if (parsed.length === 0) {
      message.warning('Не удалось разобрать ни одной строки. Проверьте формат.');
      return;
    }
    if (typeof onAppendCheckerProxies === 'function') {
      onAppendCheckerProxies(parsed);
    } else {
      message.warning('Добавление в очередь недоступно на этом экране.');
    }
  };

  const handlePickFile = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const f = e.target?.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => {
      setProxyDraft(String(reader.result || ''));
      setSourceTab('manual');
      message.success('Текст из файла загружен в поле');
    };
    reader.readAsText(f);
    e.target.value = '';
  };

  const handleLoadFromUrl = async () => {
    const u = urlInput.trim();
    if (!u) {
      message.warning('Укажите URL');
      return;
    }
    try {
      const res = await fetch(u, { method: 'GET', mode: 'cors' });
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }
      const text = await res.text();
      setProxyDraft(text);
      setSourceTab('manual');
      message.success('Текст загружен в поле');
    } catch (err) {
      message.error(
        err instanceof Error
          ? `Не удалось загрузить: ${err.message}. Если это CORS, вставьте текст вручную или через файл.`
          : 'Не удалось загрузить по URL'
      );
    }
  };

  return (
    <aside className="proxy-checker-side" aria-label="Добавление прокси в чекер">
      <input
        ref={fileInputRef}
        type="file"
        accept=".txt,.csv,text/plain"
        className="visually-hidden"
        tabIndex={-1}
        aria-hidden="true"
        onChange={handleFileChange}
      />
      <div className="proxy-checker-side__head">
        <h2 className="proxy-checker-side__title">Проверка прокси</h2>
      </div>
      <div className="proxy-checker-side__section proxy-checker-side__section--body">
        <div className="proxy-checker-side__tabs" role="tablist" aria-label="Источник прокси">
          <button
            type="button"
            role="tab"
            aria-selected={sourceTab === 'manual'}
            className={`proxy-checker-side__tab${sourceTab === 'manual' ? ' proxy-checker-side__tab--active' : ''}`}
            onClick={() => setSourceTab('manual')}
          >
            Вручную
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={sourceTab === 'file'}
            className={`proxy-checker-side__tab${sourceTab === 'file' ? ' proxy-checker-side__tab--active' : ''}`}
            onClick={() => setSourceTab('file')}
          >
            Из файла
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={sourceTab === 'url'}
            className={`proxy-checker-side__tab${sourceTab === 'url' ? ' proxy-checker-side__tab--active' : ''}`}
            onClick={() => setSourceTab('url')}
          >
            Из URL
          </button>
        </div>
        <div className="proxy-checker-side__hint">
          <p className="proxy-checker-side__hint-lead">
            Мы извлекаем прокси из текста. Поддерживаются следующие шаблоны:
          </p>
          <ul className="proxy-checker-side__format-list">
            {PROXY_CHECKER_FORMAT_TEMPLATE_LINES.map((line) => (
              <li key={line}>
                <code className="proxy-checker-side__format-code">{line}</code>
              </li>
            ))}
          </ul>
          <p className="proxy-checker-side__hint-foot">Строки, начинающиеся с #, пропускаются.</p>
        </div>
        {sourceTab === 'file' ? (
          <div className="proxy-checker-side__file-row" style={{ marginBottom: 8 }}>
            <button type="button" className="pck-cabinet-shell__queue-btn" onClick={handlePickFile}>
              Выбрать файл…
            </button>
            <span className="proxy-checker-side__hint" style={{ marginLeft: 8 }}>
              .txt / список строк
            </span>
          </div>
        ) : null}
        {sourceTab === 'url' ? (
          <div className="proxy-checker-side__url-row" style={{ marginBottom: 8, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
            <Input
              placeholder="https://example.com/proxies.txt"
              value={urlInput}
              onChange={(e) => setUrlInput(e.target.value)}
              style={{ flex: '1 1 160px', minWidth: 0 }}
            />
            <button type="button" className="pck-cabinet-shell__queue-btn" onClick={handleLoadFromUrl}>
              Загрузить
            </button>
          </div>
        ) : null}
        <label className="proxy-checker-side__textarea-wrap">
          <span className="visually-hidden">Список прокси</span>
          <textarea
            className="proxy-checker-side__textarea"
            placeholder="Введите прокси"
            value={proxyDraft}
            onChange={(e) => setProxyDraft(e.target.value)}
            rows={10}
            aria-label="Поле ввода прокси"
          />
        </label>
      </div>
      <div className="proxy-checker-side__section">
        <div className="proxy-checker-side__row">
          <span className="proxy-checker-side__toggle-label" id={toggleLabelId}>
            Включить автопроверку
          </span>
          <button
            type="button"
            className={`proxy-checker-toggle${autoCheckNew ? ' proxy-checker-toggle--on' : ' proxy-checker-toggle--off'}`}
            onClick={() => setAutoCheckNew((v) => !v)}
            role="switch"
            aria-checked={autoCheckNew}
            aria-labelledby={toggleLabelId}
          >
            <CabinetAutoCheckToggleArt isOn={autoCheckNew} />
          </button>
        </div>
      </div>
      <div className="proxy-checker-side__foot">
        <button type="button" className="proxy-checker-side__submit" onClick={handleAddProxies}>
          Добавить прокси в чекер
        </button>
      </div>
    </aside>
  );
}

function CabinetSelectAllCheckboxTh({ checked, indeterminate, disabled, onChange }) {
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(indeterminate);
    }
  }, [indeterminate]);
  return (
    <th className="proxy-checker-table__col-check" scope="col">
      <span className="proxy-checker-table__checkbox-label">
        <label className="proxy-checker-table__select-all-label">
          <input
            ref={inputRef}
            type="checkbox"
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            aria-label="Выбрать все прокси в очереди"
          />
        </label>
      </span>
    </th>
  );
}

function CabinetCheckerTableShell({
  toolbar = null,
  tbodyContent,
  onAppendCheckerProxies,
  selectAllHeader = null,
  queueFilters = null,
}) {
  const renderColFilter = (colKey) => {
    if (!queueFilters) {
      return (
        <button type="button" className="proxy-checker-menu-btn" aria-hidden="true" tabIndex={-1} disabled>
          <CabinetFilterFunnelIcon />
        </button>
      );
    }
    const {
      columnOptions,
      activeFilters,
      openFilterKey,
      setOpenFilterKey,
      onApply,
      onReset,
    } = queueFilters;
    const label = CABINET_QUEUE_FILTER_LABELS[colKey] || colKey;
    const values = columnOptions[colKey] || [];
    const hasFilter = (activeFilters[colKey] || []).length > 0;
    const isOpen = openFilterKey === colKey;
    return (
      <CabinetQueueThFilterBtn
        colKey={colKey}
        label={label}
        hasFilter={hasFilter}
        isOpen={isOpen}
        onToggle={() => setOpenFilterKey(isOpen ? null : colKey)}
        values={values}
        activeFilters={activeFilters[colKey] || []}
        onApply={onApply}
        onReset={onReset}
        onClose={() => setOpenFilterKey(null)}
      />
    );
  };

  return (
    <div className="pck-cabinet-shell">
      <div className="proxy-checker">
        <div className="proxy-checker__row">
          <div className="proxy-checker__table-column">
            <div className="proxy-checker__table-card">
              {toolbar}
              <div className="proxy-checker__grid-wrap">
                <table className="proxy-checker-table" aria-label="Таблица проверки прокси">
                  <caption className="visually-hidden">
                    Очередь чекера: скорость макс и скорость средняя (Мб/с); колонка «Замер» — кнопка измерения
                  </caption>
                  <colgroup>
                    <col className="proxy-checker-table__col-check" />
                    <col className="proxy-checker-table__col-provider" />
                    <col className="proxy-checker-table__col-host" />
                    <col className="proxy-checker-table__col-port" />
                    <col className="proxy-checker-table__col-type" />
                    <col className="proxy-checker-table__col-avail" />
                    <col className="proxy-checker-table__col-checked" />
                    <col className="proxy-checker-table__col-supplier" />
                    <col className="proxy-checker-table__col-operator" />
                    <col className="proxy-checker-table__col-speed-max" />
                    <col className="proxy-checker-table__col-speed-avg" />
                    <col className="proxy-checker-table__col-measure" />
                    <col className="proxy-checker-table__col-menu" />
                  </colgroup>
                  <thead>
                    <tr>
                      {selectAllHeader ? (
                        <CabinetSelectAllCheckboxTh {...selectAllHeader} />
                      ) : (
                        <th className="proxy-checker-table__col-check" scope="col">
                          <span className="proxy-checker-table__checkbox-label">
                            <span className="proxy-checker-table__checkbox-face" aria-hidden="true">
                              <CabinetHeaderCheckboxArt />
                            </span>
                          </span>
                        </th>
                      )}
                      <th className="proxy-checker-table__col-provider" scope="col">
                        <div className="proxy-checker-table__th-inner">
                          <span>Логин</span>
                          <CabinetSortChevronIcon />
                          {renderColFilter('provider')}
                        </div>
                      </th>
                      <th className="proxy-checker-table__col-host" scope="col">
                        <div className="proxy-checker-table__th-inner">
                          <span>Host</span>
                          <CabinetSortChevronIcon />
                          {renderColFilter('host')}
                        </div>
                      </th>
                      <th className="proxy-checker-table__col-port" scope="col">
                        <div className="proxy-checker-table__th-inner">
                          <span>Порт</span>
                          <CabinetSortChevronIcon />
                          {renderColFilter('port')}
                        </div>
                      </th>
                      <th className="proxy-checker-table__col-type" scope="col">
                        <div className="proxy-checker-table__th-inner">
                          <span>Тип прокси</span>
                          <CabinetSortChevronIcon />
                          {renderColFilter('type')}
                        </div>
                      </th>
                      <th className="proxy-checker-table__col-avail" scope="col">
                        <div className="proxy-checker-table__th-inner">
                          <span>Доступность</span>
                          <CabinetSortChevronIcon />
                          {renderColFilter('availability')}
                        </div>
                      </th>
                      <th className="proxy-checker-table__col-checked" scope="col">
                        <div className="proxy-checker-table__th-inner">
                          <span>Проверен</span>
                        </div>
                      </th>
                      <th className="proxy-checker-table__col-supplier" scope="col">
                        <div className="proxy-checker-table__th-inner">
                          <span>Поставщик</span>
                          <CabinetSortChevronIcon />
                          {renderColFilter('supplier')}
                        </div>
                      </th>
                      <th className="proxy-checker-table__col-operator" scope="col">
                        <div className="proxy-checker-table__th-inner">
                          <span>Оператор</span>
                          <CabinetSortChevronIcon />
                          {renderColFilter('operator')}
                        </div>
                      </th>
                      <th className="proxy-checker-table__col-speed-max" scope="col" title="Скорость: максимум за этап (Мб/с)">
                        <div className="proxy-checker-table__th-inner proxy-checker-table__th-inner--meter">
                          <span className="proxy-checker-table__meter-th">
                            <span className="proxy-checker-table__meter-th-title">Скорость</span>
                            <span className="proxy-checker-table__meter-th-sub">макс</span>
                          </span>
                        </div>
                      </th>
                      <th className="proxy-checker-table__col-speed-avg" scope="col" title="Скорость: средняя за этап (Мб/с)">
                        <div className="proxy-checker-table__th-inner proxy-checker-table__th-inner--meter">
                          <span className="proxy-checker-table__meter-th">
                            <span className="proxy-checker-table__meter-th-title">Скорость</span>
                            <span className="proxy-checker-table__meter-th-sub">средн.</span>
                          </span>
                        </div>
                      </th>
                      <th className="proxy-checker-table__col-measure" scope="col">
                        <div className="proxy-checker-table__th-inner proxy-checker-table__th-inner--measure">
                          <span>Замер</span>
                        </div>
                      </th>
                      <th
                        className="proxy-checker-table__col-menu proxy-checker-table__th--actions"
                        scope="col"
                        aria-label="Действия"
                      >
                        <div className="proxy-checker-table__th-menu-square" aria-hidden="true">
                          <CabinetRowMenuIcon />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tbodyContent}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <CabinetProxyCheckerSidePanel onAppendCheckerProxies={onAppendCheckerProxies} />
        </div>
      </div>
    </div>
  );
}

/**
 * Таблица детальных логов автозамены (колонки COLUMNS) — не путать с очередью ручной проверки (CabinetCheckerTableShell).
 */
const DetailedLogsTableShell = ({
  onAppendCheckerProxies,
  tbodyContent,
  showCheckerSidePanel = true,
}) => (
  <div className="pck-cabinet-shell">
    <div className="proxy-checker">
      <div className="proxy-checker__row">
        <div className="proxy-checker__table-column">
          <div className="proxy-checker__table-card">
            <div className="proxy-checker__grid-wrap">
              <div className="pck-table-wrap">
                <table className="pck-table" aria-label="Детальные логи автозамены прокси">
                  <thead>
                    <tr>
                      {COLUMNS.map((col) => (
                        <th key={col.key} className={col.cssClass}>
                          <div className="pck-th-inner">
                            <span>{col.label}</span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>{tbodyContent}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {showCheckerSidePanel ? (
          <CabinetProxyCheckerSidePanel onAppendCheckerProxies={onAppendCheckerProxies} />
        ) : null}
      </div>
    </div>
  </div>
);

const CabinetDetailedLogsEmptyShell = ({ onAppendCheckerProxies, showCheckerSidePanel = true }) => (
  <DetailedLogsTableShell
    onAppendCheckerProxies={onAppendCheckerProxies}
    showCheckerSidePanel={showCheckerSidePanel}
    tbodyContent={(
      <tr>
        <td colSpan={COLUMNS.length} className="pck-td--detailed-logs-placeholder">
          <div className="pck-empty-detailed-logs">
            <span className="pck-empty-detailed-logs__title">Нет данных</span>
            <span className="pck-empty-detailed-logs__sub">Логи появятся после выполнения автозамены прокси</span>
          </div>
        </td>
      </tr>
    )}
  />
);

/** Как в OrdersPage — кнопка обновления доступности рядом с бейджем. */
const RefreshMiniIcon = () => (
  <svg className="proxy-checker-avail__refresh" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M8.00018 1.33327C8.88451 1.33617 9.7595 1.51443 10.5745 1.85773C11.3895 2.20103 12.1283 2.70255 12.7482 3.33327H10.6668C10.49 3.33327 10.3205 3.40351 10.1954 3.52854C10.0704 3.65356 10.0002 3.82313 10.0002 3.99994C10.0002 4.17675 10.0704 4.34632 10.1954 4.47134C10.3205 4.59637 10.49 4.66661 10.6668 4.66661H13.4288C13.7571 4.66643 14.0719 4.53594 14.304 4.30381C14.5362 4.07168 14.6667 3.75689 14.6668 3.42861V0.666607C14.6668 0.489796 14.5966 0.320226 14.4716 0.195202C14.3466 0.0701777 14.177 -6.01645e-05 14.0002 -6.01645e-05V-6.01645e-05C13.8234 -6.01645e-05 13.6538 0.0701777 13.5288 0.195202C13.4037 0.320226 13.3335 0.489796 13.3335 0.666607V2.05194C12.2316 1.05958 10.8752 0.393546 9.41624 0.128439C7.95725 -0.136668 6.45326 0.00961447 5.0727 0.550905C3.69214 1.0922 2.48952 2.00712 1.59952 3.19322C0.709514 4.37932 0.16727 5.78977 0.033509 7.26661C0.0248979 7.35944 0.0357195 7.45306 0.0652843 7.54148C0.0948491 7.62991 0.142509 7.71121 0.205227 7.7802C0.267944 7.84919 0.344345 7.90436 0.429561 7.94219C0.514777 7.98002 0.606939 7.99969 0.700176 7.99994V7.99994C0.863234 8.00202 1.0212 7.94317 1.14315 7.8349C1.2651 7.72664 1.34225 7.57676 1.35951 7.41461C1.50792 5.75511 2.27149 4.21107 3.50023 3.08583C4.72897 1.96059 6.33405 1.33547 8.00018 1.33327Z"
      fill="currentColor"
    />
    <path
      d="M15.3008 8.00005C15.1377 7.99798 14.9797 8.05683 14.8578 8.16509C14.7358 8.27335 14.6587 8.42323 14.6414 8.58539C14.5312 9.85421 14.0594 11.0648 13.2819 12.0735C12.5044 13.0823 11.4538 13.8468 10.2549 14.2764C9.05592 14.7061 7.7589 14.7828 6.51767 14.4975C5.27644 14.2122 4.1431 13.5768 3.2521 12.6667H5.33344C5.51025 12.6667 5.67982 12.5965 5.80484 12.4715C5.92986 12.3464 6.0001 12.1769 6.0001 12.0001C6.0001 11.8233 5.92986 11.6537 5.80484 11.5287C5.67982 11.4036 5.51025 11.3334 5.33344 11.3334H2.57144C2.40883 11.3333 2.24781 11.3653 2.09757 11.4275C1.94733 11.4896 1.81082 11.5808 1.69584 11.6958C1.58087 11.8108 1.48968 11.9473 1.42749 12.0975C1.36531 12.2478 1.33335 12.4088 1.33344 12.5714V15.3334C1.33344 15.5102 1.40367 15.6798 1.5287 15.8048C1.65372 15.9298 1.82329 16.0001 2.0001 16.0001C2.17691 16.0001 2.34648 15.9298 2.47151 15.8048C2.59653 15.6798 2.66677 15.5102 2.66677 15.3334V13.9481C3.76866 14.9404 5.12504 15.6065 6.58404 15.8716C8.04303 16.1367 9.54702 15.9904 10.9276 15.4491C12.3081 14.9078 13.5108 13.9929 14.4008 12.8068C15.2908 11.6207 15.833 10.2102 15.9668 8.73339C15.9754 8.64055 15.9646 8.54694 15.935 8.45851C15.9054 8.37008 15.8578 8.28879 15.7951 8.2198C15.7323 8.15081 15.6559 8.09564 15.5707 8.0578C15.4855 8.01997 15.3933 8.0003 15.3001 8.00005H15.3008Z"
      fill="currentColor"
    />
  </svg>
);

/** Стрелки и сводка Мб/с — как в client-frontend OrdersPage (ProxyCheckerSpeedSummary). */
const CabinetSpeedArrowDown = () => (
  <svg
    className="proxy-checker-speed-cell__arrow proxy-checker-speed-cell__arrow--down"
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 5v11.5M12 16.5l-4.25-4.25M12 16.5l4.25-4.25"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CabinetSpeedArrowUp = () => (
  <svg
    className="proxy-checker-speed-cell__arrow proxy-checker-speed-cell__arrow--up"
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 19V7.5M12 7.5L7.75 11.75M12 7.5l4.25 4.25"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function CabinetSpeedMbpsSummary({ downloadMbps, uploadMbps }) {
  const d = downloadMbps;
  const u = uploadMbps;
  const dlStr = d != null && Number.isFinite(Number(d)) ? Number(d).toFixed(2) : '—';
  const ulStr = u != null && Number.isFinite(Number(u)) ? Number(u).toFixed(2) : '—';
  if (dlStr === '—' && ulStr === '—') {
    return <>—</>;
  }
  return (
    <>
      <span className="proxy-checker-speed-cell__metric">
        <CabinetSpeedArrowDown />
        {dlStr} Мб/с
      </span>
      <span className="proxy-checker-speed-cell__sep" aria-hidden="true">
        {' '}
        ·{' '}
      </span>
      <span className="proxy-checker-speed-cell__metric">
        <CabinetSpeedArrowUp />
        {ulStr} Мб/с
      </span>
    </>
  );
}

function CabinetRowSelectCheckbox({ checked, onChange, label }) {
  return (
    <label className="proxy-checker-table__row-check-label">
      <input type="checkbox" checked={checked} onChange={onChange} aria-label={label} />
    </label>
  );
}

function CabinetManualQueueSpeedCells({ row, busy, onMeasure, measureUi }) {
  const dla =
    row.downloadMbpsAvg != null && Number.isFinite(Number(row.downloadMbpsAvg))
      ? Number(row.downloadMbpsAvg)
      : null;
  const ula =
    row.uploadMbpsAvg != null && Number.isFinite(Number(row.uploadMbpsAvg))
      ? Number(row.uploadMbpsAvg)
      : null;
  const dlm =
    row.downloadMbpsMax != null && Number.isFinite(Number(row.downloadMbpsMax))
      ? Number(row.downloadMbpsMax)
      : row.downloadMbps != null && Number.isFinite(Number(row.downloadMbps))
        ? Number(row.downloadMbps)
        : null;
  const ulm =
    row.uploadMbpsMax != null && Number.isFinite(Number(row.uploadMbpsMax))
      ? Number(row.uploadMbpsMax)
      : row.uploadMbps != null && Number.isFinite(Number(row.uploadMbps))
        ? Number(row.uploadMbps)
        : null;

  return (
    <>
      <td className="proxy-checker-table__data-cell proxy-checker-table__col-speed-max">
        <div className="proxy-checker-speed-cell proxy-checker-speed-cell--values-only">
          {row.speedMeasureError ? (
            <div className="proxy-checker-speed-cell__err" role="alert" title={row.speedMeasureError}>
              {row.speedMeasureError}
            </div>
          ) : null}
          <span className="proxy-checker-speed-cell__summary" title={row.speedCheckedAt || undefined}>
            <CabinetSpeedMbpsSummary downloadMbps={dlm} uploadMbps={ulm} />
          </span>
        </div>
      </td>
      <td className="proxy-checker-table__data-cell proxy-checker-table__col-speed-avg">
        <div className="proxy-checker-speed-cell proxy-checker-speed-cell--avg-only">
          <span className="proxy-checker-speed-cell__summary" title={row.speedCheckedAt || undefined}>
            {dla != null || ula != null ? (
              <CabinetSpeedMbpsSummary downloadMbps={dla} uploadMbps={ula} />
            ) : (
              <span className="proxy-checker-speed-cell__empty">—</span>
            )}
          </span>
        </div>
      </td>
      <td className="proxy-checker-table__data-cell proxy-checker-table__col-measure">
        <div className="proxy-checker-measure-cell">
          {busy ? (
            <AdminSpeedMeasureProgressBar
              percent={measureUi?.percent ?? 0}
              label={measureUi?.label ?? 'Подготовка…'}
            />
          ) : (
            <button
              type="button"
              className="proxy-checker-speed-cell__btn"
              aria-label={`Замер скорости прокси ${row.host}:${row.port}`}
              onClick={() => onMeasure(row)}
            >
              Замер
            </button>
          )}
        </div>
      </td>
    </>
  );
}

/** Доступность в ячейке — как в ЛК OrdersPage: бейдж «Работает» / «Не работает» / «Не проверен». */
function CabinetAvailabilityBadge({ value }) {
  const raw = value == null ? '' : String(value).trim();
  if (!raw || raw === '—') {
    return <span className="proxy-checker-badge proxy-checker-badge--gray">Не проверен</span>;
  }
  const v = raw.toLowerCase();
  if (
    v === 'available'
    || (v.includes('доступ') && !v.includes('недоступ') && !v.includes('не доступ'))
  ) {
    return <span className="proxy-checker-badge proxy-checker-badge--green">Работает</span>;
  }
  if (v === 'unavailable' || v.includes('недоступ') || v.includes('не доступ')) {
    return <span className="proxy-checker-badge proxy-checker-badge--red">Не работает</span>;
  }
  if (v.includes('нет данных') || v.includes('неизвестно') || v === 'unknown' || v === 'none') {
    return <span className="proxy-checker-badge proxy-checker-badge--gray">Не проверен</span>;
  }
  return <span className="proxy-checker-badge proxy-checker-badge--gray">{raw}</span>;
}

function CabinetManualQueueAvailCell({ row, busy, onRefreshAvail }) {
  return (
    <div className="proxy-checker-avail">
      <button
        type="button"
        className="proxy-checker-avail__refresh-btn"
        aria-label={`Проверить доступность прокси ${row.host}:${row.port}`}
        disabled={busy}
        onClick={() => onRefreshAvail(row)}
      >
        <RefreshMiniIcon />
      </button>
      <CabinetAvailabilityBadge value={row.availability} />
    </div>
  );
}

function CabinetManualCheckerQueueShell({
  rows,
  onRunCheck,
  checking,
  onClear,
  onMeasureSpeed,
  measuringSpeedIds = new Set(),
  onCheckAvailability,
  checkingAvailIds = new Set(),
  onAppendCheckerProxies,
  selectedKeys = new Set(),
  onToggleRowSelected,
  onToggleAllSelected,
  onMassMeasureSpeed,
  massSpeedRunning = false,
  speedMeasureUiByQueueKey = {},
  resolveSupplierLabel,
  resolveOperatorLabel,
  queueFilters = null,
}) {
  const renderPageSize = 200;
  const [renderPage, setRenderPage] = useState(1);
  const renderTotalPages = Math.max(1, Math.ceil(rows.length / renderPageSize));
  useEffect(() => {
    setRenderPage((previousPage) => Math.min(previousPage, renderTotalPages));
  }, [renderTotalPages]);
  const renderedRows = useMemo(() => {
    const start = (renderPage - 1) * renderPageSize;
    return rows.slice(start, start + renderPageSize);
  }, [renderPage, rows]);
  const visibleKeys = useMemo(
    () => renderedRows.map((row) => adminQueueRowKey(row)),
    [renderedRows]
  );
  const nVisibleSelected = useMemo(
    () => visibleKeys.filter((k) => selectedKeys.has(k)).length,
    [visibleKeys, selectedKeys]
  );
  const allSelected = renderedRows.length > 0 && nVisibleSelected === renderedRows.length;
  const someSelected = nVisibleSelected > 0 && !allSelected;
  const nSelected = selectedKeys.size;

  const toolbar = (
    <div className="pck-cabinet-shell__queue-toolbar">
      <span className="pck-cabinet-shell__queue-hint">
        Прокси из «Прокси» и сторонние (справа: вручную, файл, URL) — в очереди ({rows.length})
        {renderTotalPages > 1 ? ` · страница ${renderPage}/${renderTotalPages}` : ''}
        {nSelected > 0 ? (
          <span className="pck-cabinet-shell__queue-selected"> · выбрано: {nSelected}</span>
        ) : null}
      </span>
      <button
        type="button"
        className="pck-cabinet-shell__queue-btn pck-cabinet-shell__queue-btn--primary"
        onClick={onRunCheck}
        disabled={checking || rows.length === 0}
      >
        {checking ? 'Проверка…' : 'Проверить в чекере'}
      </button>
      {renderTotalPages > 1 ? (
        <>
          <button
            type="button"
            className="pck-cabinet-shell__queue-btn"
            onClick={() => setRenderPage((page) => Math.max(1, page - 1))}
            disabled={renderPage <= 1}
            aria-label="Предыдущая страница очереди"
          >
            Назад
          </button>
          <button
            type="button"
            className="pck-cabinet-shell__queue-btn"
            onClick={() => setRenderPage((page) => Math.min(renderTotalPages, page + 1))}
            disabled={renderPage >= renderTotalPages}
            aria-label="Следующая страница очереди"
          >
            Далее
          </button>
        </>
      ) : null}
      {nSelected > 0 ? (
        <button
          type="button"
          className="pck-cabinet-shell__queue-btn pck-cabinet-shell__queue-btn--accent"
          onClick={onMassMeasureSpeed}
          disabled={massSpeedRunning || checking}
        >
          {massSpeedRunning ? 'Замер скорости…' : 'Скорость массово'}
        </button>
      ) : null}
      <button
        type="button"
        className="pck-cabinet-shell__queue-btn"
        onClick={onClear}
        disabled={checking}
        title={
          nSelected > 0
            ? 'Удалить только отмеченные строки из очереди'
            : 'Очистить весь список (ничего не выбрано)'
        }
        aria-label={
          nSelected > 0
            ? `Удалить выбранные из очереди, выбрано ${nSelected}`
            : 'Очистить весь список'
        }
      >
        {nSelected > 0 ? `Удалить выбранные (${nSelected})` : 'Очистить список'}
      </button>
    </div>
  );

  const selectAllHeader =
    renderedRows.length === 0
      ? null
      : {
          checked: allSelected,
          indeterminate: someSelected,
          disabled: checking || massSpeedRunning,
          onChange: () => onToggleAllSelected(renderedRows),
        };

  return (
    <CabinetCheckerTableShell
      toolbar={toolbar}
      onAppendCheckerProxies={onAppendCheckerProxies}
      selectAllHeader={selectAllHeader}
      queueFilters={queueFilters}
      tbodyContent={renderedRows.map((row) => {
        const rk = adminQueueRowKey(row);
        const isSel = selectedKeys.has(rk);
        return (
          <tr key={rk} className="proxy-checker-table__row">
            <td className="proxy-checker-table__data-cell proxy-checker-table__col-check">
              <CabinetRowSelectCheckbox
                checked={isSel}
                onChange={() => onToggleRowSelected(rk)}
                label={`Выбрать прокси ${row.host}:${row.port}`}
              />
            </td>
            <td className="proxy-checker-table__data-cell proxy-checker-table__col-provider">
              {formatCheckerQueueLoginCell(row)}
            </td>
            <td className="proxy-checker-table__data-cell proxy-checker-table__col-host">{row.host}</td>
            <td className="proxy-checker-table__data-cell proxy-checker-table__col-port">{row.port}</td>
            <td className="proxy-checker-table__data-cell proxy-checker-table__col-type">{row.proxy_type}</td>
            <td className="proxy-checker-table__data-cell proxy-checker-table__col-avail">
              <CabinetManualQueueAvailCell
                row={row}
                busy={checkingAvailIds.has(adminQueueBusyKey(row))}
                onRefreshAvail={onCheckAvailability}
              />
            </td>
            <td className="proxy-checker-table__data-cell proxy-checker-table__col-checked">{row.checked_at}</td>
            <td className="proxy-checker-table__data-cell proxy-checker-table__col-supplier">
              {typeof resolveSupplierLabel === 'function' ? resolveSupplierLabel(row) : '—'}
            </td>
            <td className="proxy-checker-table__data-cell proxy-checker-table__col-operator">
              {renderCheckerOperatorBadge(
                typeof resolveOperatorLabel === 'function' ? resolveOperatorLabel(row) : '—',
              )}
            </td>
            <CabinetManualQueueSpeedCells
              row={row}
              busy={measuringSpeedIds.has(adminQueueBusyKey(row))}
              onMeasure={onMeasureSpeed}
              measureUi={speedMeasureUiByQueueKey[rk]}
            />
            <td className="proxy-checker-table__data-cell proxy-checker-table__col-menu proxy-checker-table__td-menu">
              <div className="proxy-checker-table__td-menu-square" aria-hidden="true">
                <CabinetRowMenuIcon />
              </div>
            </td>
          </tr>
        );
      })}
    />
  );
}

/* ============ TABS: только автономная страница /proxy-checker (не embedded) ============ */
const STANDALONE_PROXY_CHECKER_TABS = [
  { key: 'manual-check', label: 'Проверка прокси' },
  { key: 'rules', label: 'Правила проверки' },
];

/**
 * Синхронное определение админской сессии до ответа /api/auth/me — иначе на первом кадре
 * viewerIsAdmin=false и кратко показываются вкладки «Проверка прокси» / «Правила проверки».
 */
const readViewerIsAdminSyncFromStorage = () => {
  try {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      const rStr =
        typeof user.role === 'string'
          ? user.role.toLowerCase()
          : user && typeof user.role === 'object' && user.role != null && user.role.value != null
            ? String(user.role.value).toLowerCase()
            : '';
      if (rStr) return rStr === 'admin';
    }

    const token = localStorage.getItem('token');
    if (!token) return false;
    if (token === 'demo-token') return true;

    if (token.startsWith('demo-jwt-')) {
      try {
        const base64Part = token.replace('demo-jwt-', '');
        const decoded = JSON.parse(atob(base64Part));
        const decodedRole = typeof decoded.role === 'string' ? decoded.role.toLowerCase() : null;
        return decodedRole === 'admin';
      } catch {
        return false;
      }
    }

    const parts = token.split('.');
    if (parts.length === 3) {
      try {
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
        const payload = JSON.parse(atob(padded));
        const r = payload.role;
        if (typeof r === 'string') return r.toLowerCase() === 'admin';
      } catch {
        return false;
      }
    }

    return false;
  } catch {
    return false;
  }
};

/* ========================================================= */
/* ==================== COMPONENT ========================== */
/* ========================================================= */
const ProxyChecker = ({
  embedded = false,
  embeddedActiveTab = 'detailed-replacement-logs',
}) => {
  /* ---------- DATA STATES ---------- */
  const [detailedReplacementLogs, setDetailedReplacementLogs] = useState([]);
  const [modemRebootLogs, setModemRebootLogs] = useState([]);
  const [checkRules, setCheckRules] = useState([]);
  const [krakenConnections, setKrakenConnections] = useState([]);
  const [checkerKrakenServers, setCheckerKrakenServers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDetailedLogs, setLoadingDetailedLogs] = useState(false);
  const [loadingModemRebootLogs, setLoadingModemRebootLogs] = useState(false);
  const [internalActiveTabKey, setInternalActiveTabKey] = useState(() =>
    embedded ? embeddedActiveTab : 'manual-check'
  );
  const [viewerIsAdmin, setViewerIsAdmin] = useState(() => readViewerIsAdminSyncFromStorage());

  const activeTabKey = embedded ? embeddedActiveTab : internalActiveTabKey;
  const showPageHeaderTabs = !embedded && !viewerIsAdmin;

  /* ---------- TABLE STATES ---------- */
  const [sortKey, setSortKey] = useState('initiated_at');
  const [sortDir, setSortDir] = useState('desc');
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [activeFilters, setActiveFilters] = useState({});
  const [openFilter, setOpenFilter] = useState(null);
  const [rebootSortKey, setRebootSortKey] = useState('created_at');
  const [rebootSortDir, setRebootSortDir] = useState('desc');
  const [rebootCurrentPage, setRebootCurrentPage] = useState(1);
  const [rebootActiveFilters, setRebootActiveFilters] = useState({});
  const [rebootOpenFilter, setRebootOpenFilter] = useState(null);

  /* ---------- RULES STATES ---------- */
  const [ruleModalVisible, setRuleModalVisible] = useState(false);
  const [editingRule, setEditingRule] = useState(null);
  const [ruleDraftTarget, setRuleDraftTarget] = useState('own');
  const [createRuleMenuOpen, setCreateRuleMenuOpen] = useState(false);
  const [checkingAll, setCheckingAll] = useState(false);
  const [rulesServerFilter, setRulesServerFilter] = useState([]);
  const [rulesServerFilterOpen, setRulesServerFilterOpen] = useState(false);
  const [statsVisible, setStatsVisible] = useState(false);
  const [statusData, setStatusData] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);
  const operatorTemplatesRef = useRef([]);
  const createRuleBtnRef = useRef(null);
  const createRuleMenuRef = useRef(null);
  const [form] = Form.useForm();
  const [adminCheckerQueue, setAdminCheckerQueue] = useState([]);
  const [cabinetQueueFilters, setCabinetQueueFilters] = useState({});
  const [cabinetQueueFilterOpenKey, setCabinetQueueFilterOpenKey] = useState(null);
  const [checkerQueueChecking, setCheckerQueueChecking] = useState(false);
  const [speedTestModalRow, setSpeedTestModalRow] = useState(null);
  const [availCheckBusyIds, setAvailCheckBusyIds] = useState(() => new Set());
  const [adminCheckerSelectedKeys, setAdminCheckerSelectedKeys] = useState(() => new Set());
  /** Фоновый массовый замер (модуль вне React — не обрывается при смене раздела) */
  const [massSpeedSnap, setMassSpeedSnap] = useState(() => getAdminCheckerMassSpeedSnapshot());
  /** UI замера по ключу adminQueueRowKey — только модалка одиночного замера */
  const [speedMeasureUiByQueueKey, setSpeedMeasureUiByQueueKey] = useState(() => ({}));

  const updateSpeedMeasureUiForQueueKey = useCallback((queueKey, ui) => {
    if (queueKey == null) return;
    setSpeedMeasureUiByQueueKey((prev) => ({ ...prev, [String(queueKey)]: ui }));
  }, []);

  const clearSpeedMeasureUiForQueueKey = useCallback((queueKey) => {
    if (queueKey == null) return;
    setSpeedMeasureUiByQueueKey((prev) => {
      const k = String(queueKey);
      if (!(k in prev)) return prev;
      const next = { ...prev };
      delete next[k];
      return next;
    });
  }, []);

  useEffect(() => {
    let cancelled = false;
    ensureAdminCheckerQueueLoaded().then((rows) => {
      if (!cancelled) setAdminCheckerQueue(Array.isArray(rows) ? rows : []);
    });
    const unsubQueue = subscribeAdminCheckerQueue((rows) => {
      setAdminCheckerQueue(Array.isArray(rows) ? rows : []);
    });
    return () => {
      cancelled = true;
      unsubQueue();
      void flushAdminCheckerQueueNow();
    };
  }, []);

  useEffect(() => {
    const unsub = subscribeAdminCheckerMassSpeed((snap) => {
      setMassSpeedSnap(snap);
    });
    return unsub;
  }, []);

  useEffect(() => {
    setCabinetQueueFilters((prev) => {
      if (!prev || typeof prev !== 'object') return prev;
      let changed = false;
      const next = { ...prev };
      CABINET_QUEUE_NO_FILTER_COL_KEYS.forEach((k) => {
        if (Object.prototype.hasOwnProperty.call(next, k)) {
          delete next[k];
          changed = true;
        }
      });
      return changed ? next : prev;
    });
    setCabinetQueueFilterOpenKey((k) => (k && CABINET_QUEUE_NO_FILTER_COL_KEYS.has(k) ? null : k));
  }, []);

  const setActiveTabKey = useCallback((key) => {
    if (embedded) return;
    setInternalActiveTabKey(key);
  }, [embedded]);

  const handleCloseRuleModal = useCallback(() => {
    setCreateRuleMenuOpen(false);
    setRuleModalVisible(false);
    setEditingRule(null);
    setRuleDraftTarget('own');
    form.resetFields();
  }, [form]);

  // Затемнение закрывает форму правила только настоящим щелчком — нажатие и отпускание на нём (владелец 29.10, DF85)
  const ruleBackdrop = useBackdropClose(handleCloseRuleModal);

  useEffect(() => {
    if (!ruleModalVisible) {
      return undefined;
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        handleCloseRuleModal();
      }
    };
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.removeEventListener('keydown', handleEscape);
    };
  }, [ruleModalVisible, handleCloseRuleModal]);

  const handleOpenRuleModalForTarget = useCallback((target) => {
    setCreateRuleMenuOpen(false);
    setEditingRule(null);
    setRuleDraftTarget(target === 'foreign' ? 'foreign' : 'own');
    form.resetFields();
    setRuleModalVisible(true);
  }, [form]);

  useEffect(() => {
    if (!createRuleMenuOpen) return undefined;
    const handleDocumentPointerDown = (event) => {
      const target = event.target;
      if (createRuleBtnRef.current?.contains(target) || createRuleMenuRef.current?.contains(target)) {
        return;
      }
      setCreateRuleMenuOpen(false);
    };
    const handleDocumentEscape = (event) => {
      if (event.key === 'Escape') {
        setCreateRuleMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleDocumentPointerDown);
    document.addEventListener('keydown', handleDocumentEscape);
    return () => {
      document.removeEventListener('mousedown', handleDocumentPointerDown);
      document.removeEventListener('keydown', handleDocumentEscape);
    };
  }, [createRuleMenuOpen]);

  useEffect(() => {
    let cancelled = false;
    if (embedded) {
      return undefined;
    }
    (async () => {
      try {
        const res = await apiService.getCurrentUser();
        const r = res?.data?.role;
        const rStr =
          typeof r === 'string'
            ? r.toLowerCase()
            : r && typeof r === 'object' && r.value != null
              ? String(r.value).toLowerCase()
              : '';
        if (!cancelled) setViewerIsAdmin(rStr === 'admin');
      } catch {
        if (!cancelled) setViewerIsAdmin(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [embedded]);

  const loadOperatorTemplates = useCallback(async () => {
    try {
      const response = await apiService.getOperatorTemplates();
      const rawTemplates =
        response?.data?.data?.templates ||
        response?.data?.templates ||
        [];
      operatorTemplatesRef.current = normalizeOperatorTemplates(rawTemplates);
    } catch {
      operatorTemplatesRef.current = [];
    }
  }, []);

  const loadStatusData = useCallback(async () => {
    setStatusLoading(true);
    try {
      const [statsResult, portsResult, connectionsResult, modemsStatusResult] = await Promise.allSettled([
        apiService.getStats(),
        apiService.getAllKrakenModems(),
        apiService.getKrakenConnections(),
        apiService.getModemsStatusByProxy().catch(() => ({ data: {} })),
      ]);

      const normalizedStats = statsResult.status === 'fulfilled'
        ? parseStatsPayloadFromApi(statsResult.value)
        : null;

      const operatorTemplates = operatorTemplatesRef.current || [];
      const portsRaw = portsResult.status === 'fulfilled'
        ? extractPortsArray(portsResult.value)
        : [];
      const modemsStatusData = modemsStatusResult.status === 'fulfilled'
        ? extractModemsStatusList(modemsStatusResult.value)
        : [];
      const portsWithModemStatus = buildPortsWithModemStatus(portsRaw, modemsStatusData);
      const connections = connectionsResult.status === 'fulfilled'
        ? (connectionsResult.value?.data?.connections || connectionsResult.value?.data?.data?.connections || [])
        : [];
      const modemStatsForPanel = mergeModemStatsForPanel(connections, portsWithModemStatus);

      const forSaleStats = buildForSaleStats({
        ports: portsWithModemStatus,
        connections,
        operatorTemplates,
        resolveOperatorByTemplates,
        dashboardStats: normalizedStats,
      });

      setStatusData({
        ...(normalizedStats || {}),
        ...forSaleStats,
        ...(modemStatsForPanel || {}),
      });
    } catch {
      setStatusData(null);
    } finally {
      setStatusLoading(false);
    }
  }, []);

  /* ========== RUN CHECK ALL ========== */
  const handleRunCheckAll = useCallback(async () => {
    try {
      setCheckingAll(true);
      const res = await apiService.quickCheckAllProxies();
      const d = res.data?.data || res.data || {};
      const avail = d.available ?? 0;
      const unavail = d.unavailable ?? 0;
      const errs = d.errors ?? 0;
      message.success(`Проверка завершена: доступно ${avail}, недоступно ${unavail}${errs ? `, ошибок ${errs}` : ''}`);
      loadStatusData();
    } catch (error) {
      message.error('Ошибка запуска проверки: ' + (error.response?.data?.detail || error.message));
    } finally {
      setCheckingAll(false);
    }
  }, [loadStatusData]);

  /* ========== DATA LOADING ========== */
  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const [rulesData, serversData, krakenSrvData] = await Promise.allSettled([
        apiService.getCheckRules(),
        apiService.getProxyCheckerKrakenConnections(),
        apiService.getProxyCheckerKrakenServers(),
      ]);

      const processResult = (result) => {
        if (result.status === 'fulfilled') return result.value;
        return { data: [] };
      };

      const processedRulesData = processResult(rulesData);
      const processedServersData = processResult(serversData);
      const processedKrakenSrvData = processResult(krakenSrvData);

      let safeRules = [];
      if (processedRulesData?.data && Array.isArray(processedRulesData.data)) {
        safeRules = processedRulesData.data;
      } else if (processedRulesData?.data?.data && Array.isArray(processedRulesData.data.data)) {
        safeRules = processedRulesData.data.data;
      } else if (Array.isArray(processedRulesData)) {
        safeRules = processedRulesData;
      }
      safeRules = safeRules.map(rule => ({
        ...rule,
        rule_target: rule.rule_target === 'foreign' ? 'foreign' : 'own',
        quick_availability_interval: rule.quick_availability_interval ?? 15,
        down_notification_interval_minutes: rule.down_notification_interval_minutes ?? 15,
        modem_reboot_enabled: rule.modem_reboot_enabled === true,
        modem_reboot_first_delay_minutes: rule.modem_reboot_first_delay_minutes ?? 15,
        modem_reboot_second_delay_minutes: rule.modem_reboot_second_delay_minutes ?? 30,
      }));

      let safeConnections = [];
      if (processedServersData?.data && Array.isArray(processedServersData.data)) {
        safeConnections = processedServersData.data;
      } else if (processedServersData?.data?.data && Array.isArray(processedServersData.data.data)) {
        safeConnections = processedServersData.data.data;
      }

      let safeKrakenServers = [];
      if (processedKrakenSrvData?.data && Array.isArray(processedKrakenSrvData.data)) {
        safeKrakenServers = processedKrakenSrvData.data;
      } else if (processedKrakenSrvData?.data?.data && Array.isArray(processedKrakenSrvData.data.data)) {
        safeKrakenServers = processedKrakenSrvData.data.data;
      }

      setCheckRules(safeRules);
      setKrakenConnections(safeConnections);
      setCheckerKrakenServers(safeKrakenServers);
    } catch (error) {
      message.error(`Ошибка загрузки данных: ${error.message}`);
      setCheckRules([]);
      setKrakenConnections([]);
      setCheckerKrakenServers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadDetailedReplacementLogs = useCallback(async () => {
    setLoadingDetailedLogs(true);
    try {
      const response = await apiService.getDetailedReplacementLogs();
      const data = response?.data;
      let safeDetailedLogs = [];
      if (data?.data && Array.isArray(data.data)) {
        safeDetailedLogs = data.data;
      } else if (data?.data?.data && Array.isArray(data.data.data)) {
        safeDetailedLogs = data.data.data;
      } else if (Array.isArray(data)) {
        safeDetailedLogs = data;
      } else if (data?.success && data?.data && Array.isArray(data.data)) {
        safeDetailedLogs = data.data;
      }
      setDetailedReplacementLogs(safeDetailedLogs);
    } catch (error) {
      message.error(`Ошибка загрузки детальных логов: ${error?.message || error}`);
      setDetailedReplacementLogs([]);
    } finally {
      setLoadingDetailedLogs(false);
    }
  }, []);

  const loadModemRebootLogs = useCallback(async () => {
    setLoadingModemRebootLogs(true);
    try {
      // В таблице показываем итог одной фактически выполненной попытки.
      // Guard/queued — технические события, а не результаты перезагрузки.
      const response = await apiService.getModemRebootLogs({
        limit: 200,
        hours: 168,
        event_type: 'completed',
      });
      const payload = response?.data;
      const rows = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload)
          ? payload
          : [];
      setModemRebootLogs(rows);
    } catch (error) {
      message.error(`Ошибка загрузки логов перезагрузки: ${error?.message || error}`);
      setModemRebootLogs([]);
    } finally {
      setLoadingModemRebootLogs(false);
    }
  }, []);

  useEffect(() => { loadData(); }, [loadData]);

  useEffect(() => {
    loadOperatorTemplates().then(() => loadStatusData());
  }, [loadOperatorTemplates, loadStatusData]);

  const handleStatsToggle = useCallback(() => {
    setStatsVisible((prev) => {
      const next = !prev;
      if (next) {
        loadStatusData();
      }
      return next;
    });
  }, [loadStatusData]);

  const activeFilterCount = useMemo(() => {
    if (activeTabKey === 'rules') {
      return rulesServerFilter.length > 0 ? 1 : 0;
    }
    if (activeTabKey === 'detailed-replacement-logs') {
      return Object.values(activeFilters).filter((v) => v && v.length > 0).length;
    }
    if (activeTabKey === 'modem-reboot-logs') {
      return Object.values(rebootActiveFilters).filter((v) => v && v.length > 0).length;
    }
    if (activeTabKey === 'manual-check') {
      return Object.values(cabinetQueueFilters || {}).filter((v) => v && v.length > 0).length;
    }
    return 0;
  }, [activeFilters, rebootActiveFilters, rulesServerFilter, activeTabKey, cabinetQueueFilters]);

  const handleClearAllFilters = useCallback(() => {
    if (activeTabKey === 'rules') {
      setRulesServerFilter([]);
      setRulesServerFilterOpen(false);
      return;
    }
    if (activeTabKey === 'detailed-replacement-logs') {
      setActiveFilters({});
      setOpenFilter(null);
      return;
    }
    if (activeTabKey === 'modem-reboot-logs') {
      setRebootActiveFilters({});
      setRebootOpenFilter(null);
      return;
    }
    if (activeTabKey === 'manual-check') {
      setCabinetQueueFilters({});
      setCabinetQueueFilterOpenKey(null);
    }
  }, [activeTabKey]);

  useEffect(() => {
    if (activeTabKey === 'detailed-replacement-logs') {
      loadDetailedReplacementLogs();
    }
  }, [activeTabKey, loadDetailedReplacementLogs]);

  useEffect(() => {
    if (activeTabKey === 'modem-reboot-logs') {
      setRebootSortKey('created_at');
      setRebootSortDir('desc');
      setRebootCurrentPage(1);
      loadModemRebootLogs();
    }
  }, [activeTabKey, loadModemRebootLogs]);

  useEffect(() => {
    const valid = new Set(adminCheckerQueue.map((r) => adminQueueRowKey(r)));
    setAdminCheckerSelectedKeys((prev) => {
      const next = new Set([...prev].filter((k) => valid.has(k)));
      return next.size === prev.size && [...prev].every((k) => next.has(k)) ? prev : next;
    });
    setSpeedMeasureUiByQueueKey((prev) => {
      const entries = Object.entries(prev).filter(([key]) => valid.has(key));
      if (entries.length === Object.keys(prev).length) {
        return prev;
      }
      return Object.fromEntries(entries);
    });
  }, [adminCheckerQueue]);

  const handleAppendCheckerProxiesFromDraft = useCallback((parsedLines) => {
    if (!Array.isArray(parsedLines) || parsedLines.length === 0) {
      message.warning('Нет строк для добавления');
      return;
    }
    setAdminCheckerQueue((prev) => {
      const next = [...prev];
      for (const p of parsedLines) {
        const external_key =
          typeof crypto !== 'undefined' && crypto.randomUUID
            ? crypto.randomUUID()
            : `ext_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
        next.push({
          proxy_id: null,
          is_external: true,
          external_key,
          host: p.host,
          port: String(p.port),
          proxy_type: p.proxyType,
          login: p.username || '',
          password: p.password || '',
          checker_line: buildAdminCheckerLineFromParsed(p),
          availability: '—',
          auto_check: '—',
          checked_at: '—',
          provider: String((p.username || '').trim()) || '—',
          speed: '—',
        });
      }
      writeAdminCheckerQueue(next);
      return next;
    });
    message.success(`Добавлено в чекер: ${parsedLines.length}`);
  }, []);

  const handleAdminCheckerQueueMassCheck = useCallback(async () => {
    const q = readAdminCheckerQueue();
    const ids = q.map((e) => e.proxy_id).filter((n) => n != null && Number.isFinite(Number(n)));
    const externalRows = q.filter((e) => e.is_external && e.external_key);
    if (ids.length === 0 && externalRows.length === 0) {
      message.warning('Нет прокси в списке');
      return;
    }
    setCheckerQueueChecking(true);
    try {
      if (ids.length > 0) {
        await apiService.massCheckProxies(ids, 'quick_availability');
        const checkedAtBatch = formatAdminQueueAvailabilityCheckedAtNow();
        const idSet = new Set(ids.map((x) => Number(x)));
        setAdminCheckerQueue((prev) => {
          const next = prev.map((r) => {
            const pid = r.proxy_id != null ? Number(r.proxy_id) : NaN;
            if (Number.isFinite(pid) && idSet.has(pid)) {
              return { ...r, checked_at: checkedAtBatch };
            }
            return r;
          });
          writeAdminCheckerQueue(next);
          return next;
        });
      }
      for (const row of externalRows) {
        const res = await apiService.proxyCheckerAdhocQuickAvailability({
          host: String(row.host || '').trim(),
          port: Number(row.port),
          proxy_type: proxyTypeForAdhocApi(row),
          username: row.login || null,
          password: row.password || null,
        });
        const data = res?.data?.data ?? res?.data;
        const st = (data?.status || '').toString().toLowerCase();
        let availabilityLabel = 'Нет данных';
        if (st === 'available') {
          availabilityLabel = 'Доступен';
        } else if (st === 'unavailable' || st === 'error') {
          availabilityLabel = 'Недоступен';
        }
        const k = row.external_key;
        const checkedAt = formatAdminQueueAvailabilityCheckedAtNow();
        setAdminCheckerQueue((prev) => {
          const mapped = prev.map((r) => (r.external_key === k ? { ...r, availability: availabilityLabel, checked_at: checkedAt } : r));
          writeAdminCheckerQueue(mapped);
          return mapped;
        });
      }
      const n = ids.length + externalRows.length;
      message.success(ids.length ? `Проверка: ${n} прокси` : `Проверка сторонних: ${externalRows.length}`);
      loadStatusData();
    } catch (error) {
      message.error(error.response?.data?.detail || error.message || 'Ошибка проверки');
    } finally {
      setCheckerQueueChecking(false);
    }
  }, [loadStatusData]);

  const resolveCheckerSupplierLabel = useCallback(
    (row) => resolveProxyCheckerSupplierLabel(row, krakenConnections, checkerKrakenServers),
    [krakenConnections, checkerKrakenServers]
  );

  const resolveCheckerOperatorLabel = useCallback(
    (row) =>
      formatCheckerQueueOperatorCell(
        row,
        resolveCheckerSupplierLabel,
        operatorTemplatesRef.current || []
      ),
    [resolveCheckerSupplierLabel]
  );

  const cabinetQueueFilterColumnOptions = useMemo(
    () =>
      buildCabinetQueueFilterOptions(
        adminCheckerQueue,
        resolveCheckerSupplierLabel,
        operatorTemplatesRef.current || []
      ),
    [adminCheckerQueue, resolveCheckerSupplierLabel]
  );

  const cabinetQueueFilteredRows = useMemo(
    () =>
      filterCabinetQueueRowsBySnapshot(
        adminCheckerQueue,
        cabinetQueueFilters,
        resolveCheckerSupplierLabel,
        operatorTemplatesRef.current || []
      ),
    [adminCheckerQueue, cabinetQueueFilters, resolveCheckerSupplierLabel]
  );

  const handleCabinetQueueFilterApply = useCallback((column, vals) => {
    setCabinetQueueFilters((prev) => ({ ...prev, [column]: vals }));
  }, []);

  const handleCabinetQueueFilterReset = useCallback((column) => {
    setCabinetQueueFilters((prev) => {
      const next = { ...prev };
      delete next[column];
      return next;
    });
  }, []);

  const cabinetQueueFiltersApi = useMemo(
    () => ({
      columnOptions: cabinetQueueFilterColumnOptions,
      activeFilters: cabinetQueueFilters,
      openFilterKey: cabinetQueueFilterOpenKey,
      setOpenFilterKey: setCabinetQueueFilterOpenKey,
      onApply: handleCabinetQueueFilterApply,
      onReset: handleCabinetQueueFilterReset,
    }),
    [
      cabinetQueueFilterColumnOptions,
      cabinetQueueFilters,
      cabinetQueueFilterOpenKey,
      handleCabinetQueueFilterApply,
      handleCabinetQueueFilterReset,
    ]
  );

  const handleClearAdminCheckerQueue = useCallback(() => {
    const sel = adminCheckerSelectedKeys;
    if (sel.size > 0) {
      setAdminCheckerQueue((prev) => {
        const next = prev.filter((r) => !sel.has(adminQueueRowKey(r)));
        writeAdminCheckerQueue(next);
        return next;
      });
      setAdminCheckerSelectedKeys(new Set());
      void flushAdminCheckerQueueNow();
      message.info(`Удалено из очереди: ${sel.size}`);
      return;
    }
    clearAdminCheckerQueue();
    setAdminCheckerQueue([]);
    setAdminCheckerSelectedKeys(new Set());
    setCabinetQueueFilters({});
    setCabinetQueueFilterOpenKey(null);
    message.info('Список очищен');
  }, [adminCheckerSelectedKeys]);

  const handleToggleAdminCheckerRowSelected = useCallback((rowKey) => {
    setAdminCheckerSelectedKeys((prev) => {
      const next = new Set(prev);
      if (next.has(rowKey)) {
        next.delete(rowKey);
      } else {
        next.add(rowKey);
      }
      return next;
    });
  }, []);

  const handleToggleAdminCheckerSelectAll = useCallback((visibleRows) => {
    const list = Array.isArray(visibleRows) && visibleRows.length > 0 ? visibleRows : adminCheckerQueue;
    setAdminCheckerSelectedKeys((prev) => {
      const allKeys = list.map((r) => adminQueueRowKey(r));
      if (allKeys.length === 0) return prev;
      const allSelectedNow = allKeys.every((k) => prev.has(k));
      if (allSelectedNow) {
        const next = new Set(prev);
        allKeys.forEach((k) => next.delete(k));
        return next;
      }
      const next = new Set(prev);
      allKeys.forEach((k) => next.add(k));
      return next;
    });
  }, [adminCheckerQueue]);

  const handleMassAdminCheckerSpeed = useCallback(async () => {
    await startAdminCheckerMassSpeed(adminCheckerSelectedKeys);
  }, [adminCheckerSelectedKeys]);

  const handleAdminQueueOpenSpeedTest = useCallback((row) => {
    if (!row) return;
    if (row.is_external) {
      if (!row.external_key) return;
    } else if (!Number.isFinite(Number(row.proxy_id))) {
      return;
    }
    setSpeedTestModalRow(row);
  }, []);

  const handleAdminSpeedTestComplete = useCallback((payload) => {
    const rid = String(payload.rowId);
    if (!rid) return;

    let dl = payload.downloadMbps;
    let ul = payload.uploadMbps;
    dl = dl != null && Number.isFinite(Number(dl)) ? Number(dl) : null;
    ul = ul != null && Number.isFinite(Number(ul)) ? Number(ul) : null;
    const dlAvg =
      payload.downloadMbpsAvg != null && Number.isFinite(Number(payload.downloadMbpsAvg))
        ? Number(payload.downloadMbpsAvg)
        : null;
    const ulAvg =
      payload.uploadMbpsAvg != null && Number.isFinite(Number(payload.uploadMbpsAvg))
        ? Number(payload.uploadMbpsAvg)
        : null;
    const dlMax =
      payload.downloadMbpsMax != null && Number.isFinite(Number(payload.downloadMbpsMax))
        ? Number(payload.downloadMbpsMax)
        : dl;
    const ulMax =
      payload.uploadMbpsMax != null && Number.isFinite(Number(payload.uploadMbpsMax))
        ? Number(payload.uploadMbpsMax)
        : ul;

    setAdminCheckerQueue((prev) => {
      const next = prev.map((r) => {
        const matchExt = r.external_key != null && String(r.external_key) === rid;
        const matchId = r.proxy_id != null && String(r.proxy_id) === rid;
        if (!matchExt && !matchId) return r;
        return {
          ...r,
          downloadMbps: dl,
          uploadMbps: ul,
          downloadMbpsAvg: dlAvg,
          uploadMbpsAvg: ulAvg,
          downloadMbpsMax: dlMax,
          uploadMbpsMax: ulMax,
          speedMeasureError: undefined,
          speedCheckedAt: payload.speedCheckedAt,
          speed:
            dl != null || ul != null
              ? `${dl != null ? `${dl.toFixed(2)} ↓` : '—'} · ${ul != null ? `${ul.toFixed(2)} ↑` : '—'} Мб/с`
              : '—',
        };
      });
      writeAdminCheckerQueue(next);
      return next;
    });
    const match = adminCheckerQueue.find(
      (r) =>
        (r.external_key != null && String(r.external_key) === rid) ||
        (r.proxy_id != null && String(r.proxy_id) === rid)
    );
    if (match) {
      clearSpeedMeasureUiForQueueKey(adminQueueRowKey(match));
    }
    message.success('Скорость измерена');
  }, [adminCheckerQueue, clearSpeedMeasureUiForQueueKey]);

  const mergedSpeedMeasureUiByQueueKey = useMemo(
    () => ({ ...massSpeedSnap.speedMeasureUiByQueueKey, ...speedMeasureUiByQueueKey }),
    [massSpeedSnap.speedMeasureUiByQueueKey, speedMeasureUiByQueueKey]
  );

  const speedMeasureBusyIds = useMemo(() => {
    const s = new Set(massSpeedSnap.massSpeedBusyIds);
    if (speedTestModalRow) {
      const k = adminQueueBusyKey(speedTestModalRow);
      if (k != null) {
        s.add(k);
      }
    }
    return s;
  }, [speedTestModalRow, massSpeedSnap.massSpeedBusyIds]);

  const handleAdminQueueAvailCheck = useCallback(async (row) => {
    if (!row) return;
    const busyKey = adminQueueBusyKey(row);
    if (busyKey == null) return;

    setAvailCheckBusyIds((prev) => {
      if (prev.has(busyKey)) return prev;
      const next = new Set(prev);
      next.add(busyKey);
      return next;
    });

    try {
      if (row.is_external) {
        const response = await apiService.proxyCheckerAdhocQuickAvailability({
          host: String(row.host || '').trim(),
          port: Number(row.port),
          proxy_type: proxyTypeForAdhocApi(row),
          username: row.login || null,
          password: row.password || null,
        });
        const data = response?.data?.data ?? response?.data;
        const st = (data?.status || '').toString().toLowerCase();
        let availabilityLabel = 'Нет данных';
        if (st === 'available') {
          availabilityLabel = 'Доступен';
        } else if (st === 'unavailable' || st === 'error') {
          availabilityLabel = 'Недоступен';
        }
        const checkedAt = formatAdminQueueAvailabilityCheckedAtNow();
        setAdminCheckerQueue((prev) => {
          const next = prev.map((r) =>
            r.external_key === row.external_key ? { ...r, availability: availabilityLabel, checked_at: checkedAt } : r
          );
          writeAdminCheckerQueue(next);
          return next;
        });
        message.success('Доступность проверена');
        return;
      }

      const id = Number(row.proxy_id);
      if (!Number.isFinite(id)) return;

      const response = await apiService.checkProxy(id, 'quick_availability');
      const envelope = response?.data?.data ?? response?.data;
      const results = envelope?.results ?? {};
      const qa =
        results.quick_availability
        || response?.data?.result
        || response?.data?.data?.result
        || results;
      const raw = (qa?.availability_status ?? qa?.status ?? '').toString().toLowerCase();
      let availabilityLabel = 'Нет данных';
      if (raw === 'available' || raw === 'доступен') {
        availabilityLabel = 'Доступен';
      } else if (raw === 'unavailable' || raw === 'недоступен' || raw === 'error') {
        availabilityLabel = 'Недоступен';
      } else if (qa?.availability_status || qa?.status) {
        availabilityLabel = String(qa.availability_status ?? qa.status);
      }

      const checkedAt = formatAdminQueueAvailabilityCheckedAtNow();
      setAdminCheckerQueue((prev) => {
        const next = prev.map((r) =>
          r.proxy_id === id ? { ...r, availability: availabilityLabel, checked_at: checkedAt } : r
        );
        writeAdminCheckerQueue(next);
        return next;
      });
      message.success('Доступность проверена');
    } catch (error) {
      message.error(error.response?.data?.detail || error.message || 'Ошибка проверки доступности');
    } finally {
      setAvailCheckBusyIds((prev) => {
        const next = new Set(prev);
        next.delete(busyKey);
        return next;
      });
    }
  }, []);

  useEffect(() => {
    if (ruleModalVisible && !editingRule) {
      form.setFieldsValue({
        rule_target: ruleDraftTarget,
        apply_to_all_connections: true,
        kraken_connection_ids: [],
        quick_availability_interval: 15,
        down_notification_interval_minutes: 15,
        modem_reboot_enabled: false,
        modem_reboot_first_delay_minutes: 15,
        modem_reboot_second_delay_minutes: 30,
        retry_attempts: 3,
        retry_delay: 1,
        auto_replace_enabled: false,
        replacement_attempts: 3,
        max_parallel_checks: 10,
        is_active: true,
      });
    }
  }, [ruleModalVisible, editingRule, form, ruleDraftTarget]);

  /* ========== RULES HANDLERS ========== */
  const handleCreateRule = useCallback(async (values) => {
    try {
      const ruleTarget = values.rule_target === 'foreign' ? 'foreign' : 'own';
      let quick_availability_urls = [];
      if (values.quick_availability_urls) {
        quick_availability_urls = values.quick_availability_urls
          .split('\n').map(u => u.trim()).filter(u => u.length > 0);
      }
      if (quick_availability_urls.length === 0) {
        quick_availability_urls = [
          'https://laminat98.ru/ip.php',
          'https://polteplov.ru/ip.php',
        ];
      }

      const hasSelected = values.kraken_connection_ids && values.kraken_connection_ids.length > 0;
      const applyToAll = ruleTarget === 'foreign'
        ? true
        : (hasSelected ? false : (values.apply_to_all_connections !== false));
      const connectionIds = ruleTarget === 'foreign' ? [] : (applyToAll ? [] : (values.kraken_connection_ids || []));

      const ruleData = {
        ...values,
        rule_target: ruleTarget,
        kraken_connection_ids: connectionIds,
        apply_to_all_connections: applyToAll,
        quick_availability_urls,
        kraken_server_ids: values.kraken_server_ids || [],
        apply_to_all_servers: values.apply_to_all_servers !== false,
      };

      if (ruleData.quick_availability_interval == null) {
        ruleData.quick_availability_interval = 15;
      }
      if (ruleData.down_notification_interval_minutes == null) {
        ruleData.down_notification_interval_minutes = 15;
      }
      if (ruleData.modem_reboot_enabled == null) {
        ruleData.modem_reboot_enabled = false;
      }
      if (ruleData.modem_reboot_first_delay_minutes == null) {
        ruleData.modem_reboot_first_delay_minutes = 15;
      }
      if (ruleData.modem_reboot_second_delay_minutes == null) {
        ruleData.modem_reboot_second_delay_minutes = 30;
      }
      ruleData.modem_reboot_second_delay_minutes = Math.max(
        Number(ruleData.modem_reboot_second_delay_minutes || 0),
        Number(ruleData.modem_reboot_first_delay_minutes || 0),
      );

      if (editingRule) {
        await apiService.updateCheckRule(editingRule.id, ruleData);
        message.success('Правило обновлено');
        setEditingRule(null);
      } else {
        await apiService.createCheckRule(ruleData);
        message.success('Правило создано');
      }

      setRuleModalVisible(false);
      setRuleDraftTarget('own');
      form.resetFields();
      setTimeout(() => loadData(), 500);
    } catch (error) {
      message.error(editingRule ? 'Ошибка обновления правила' : 'Ошибка создания правила');
    }
  }, [loadData, form, editingRule]);

  const handleDeleteRule = useCallback(async (rule) => {
    Modal.confirm({
      title: 'Удалить правило проверки',
      content: `Вы уверены, что хотите удалить правило "${rule.name}"? Это действие нельзя отменить.`,
      okText: 'Удалить',
      okType: 'danger',
      cancelText: 'Отмена',
      onOk: async () => {
        try {
          const response = await apiService.deleteCheckRule(rule.id);
          if (response.data && response.data.success === false) {
            if (response.data.data && response.data.data.affected_groups > 0) {
              Modal.confirm({
                title: 'Правило используется в группах',
                content: `Правило "${rule.name}" используется в ${response.data.data.affected_groups} группах прокси. Хотите принудительно удалить?`,
                okText: 'Принудительно удалить',
                okType: 'danger',
                cancelText: 'Отмена',
                onOk: async () => {
                  try {
                    await apiService.deleteCheckRule(rule.id, true);
                    message.success(`Правило "${rule.name}" принудительно удалено`);
                    loadData();
                  } catch { message.error('Ошибка принудительного удаления'); }
                },
              });
            } else {
              message.error(response.data.message || 'Ошибка удаления правила');
            }
          } else {
            message.success(`Правило "${rule.name}" удалено`);
            loadData();
          }
        } catch (error) {
          message.error(error.response?.data?.detail || 'Ошибка удаления правила');
        }
      },
    });
  }, [loadData]);

  const handleToggleRuleStatus = useCallback(async (rule) => {
    try {
      await apiService.updateCheckRule(rule.id, { is_active: !rule.is_active });
      message.success(`Правило "${rule.name}" ${rule.is_active ? 'деактивировано' : 'активировано'}`);
      loadData();
    } catch { message.error('Ошибка изменения статуса правила'); }
  }, [loadData]);

  const handleEditRule = useCallback((rule) => {
    let urls = rule.quick_availability_urls || [];
    if (typeof urls === 'string') { try { urls = JSON.parse(urls); } catch { urls = []; } }

    let connectionIds = rule.kraken_connection_ids || [];
    if (connectionIds.length === 0 && rule.proxy_groups?.length > 0) {
      connectionIds = [...new Set(rule.proxy_groups.filter(g => g.kraken_connection_id).map(g => g.kraken_connection_id))];
    }
    let applyToAll = connectionIds.length === 0;
    if (rule.apply_to_all_connections !== undefined && rule.apply_to_all_connections !== null) {
      if (connectionIds.length > 0 && rule.apply_to_all_connections === true) applyToAll = false;
      else if (connectionIds.length === 0 && rule.apply_to_all_connections === false) applyToAll = true;
      else applyToAll = rule.apply_to_all_connections;
    }

    setEditingRule(rule);
    setRuleDraftTarget(rule.rule_target === 'foreign' ? 'foreign' : 'own');
    setRuleModalVisible(true);
    requestAnimationFrame(() => {
      form.setFieldsValue({
        rule_target: rule.rule_target === 'foreign' ? 'foreign' : 'own',
        name: rule.name,
        description: rule.description,
        is_active: rule.is_active,
        quick_availability_interval: rule.quick_availability_interval ?? 15,
        down_notification_interval_minutes: rule.down_notification_interval_minutes ?? 15,
        modem_reboot_enabled: rule.modem_reboot_enabled === true,
        modem_reboot_first_delay_minutes: rule.modem_reboot_first_delay_minutes ?? 15,
        modem_reboot_second_delay_minutes: rule.modem_reboot_second_delay_minutes ?? 30,
        quick_availability_urls: urls.length > 0 ? urls.join('\n') : '',
        retry_attempts: rule.retry_attempts,
        retry_delay: rule.retry_delay,
        auto_replace_enabled: rule.auto_replace_enabled,
        replacement_attempts: rule.replacement_attempts,
        max_parallel_checks: rule.max_parallel_checks ?? 10,
        kraken_connection_ids: connectionIds,
        apply_to_all_connections: applyToAll,
        kraken_server_ids: [],
      });
    });
  }, [form]);

  /* ========== SORTING ========== */
  const handleSort = useCallback((key) => {
    setSortKey(prev => {
      if (prev === key) {
        setSortDir(d => d === 'asc' ? 'desc' : 'asc');
        return key;
      }
      setSortDir('asc');
      return key;
    });
    setCurrentPage(1);
  }, []);

  const handleRebootSort = useCallback((key) => {
    setRebootSortKey((previousKey) => {
      if (previousKey === key) {
        setRebootSortDir((direction) => direction === 'asc' ? 'desc' : 'asc');
        return key;
      }
      setRebootSortDir('asc');
      return key;
    });
    setRebootCurrentPage(1);
  }, []);

  /* ========== FILTER HANDLERS ========== */
  const getColumnValues = useCallback((key) => {
    const unique = new Set();
    detailedReplacementLogs.forEach((row) => {
      const val = getCellValue(row, key);
      if (val && val !== '-' && val !== '—') unique.add(String(val));
    });
    return Array.from(unique).sort((a, b) => a.localeCompare(b, 'ru'));
  }, [detailedReplacementLogs]);

  const getRebootColumnValues = useCallback((key) => {
    const unique = new Set();
    modemRebootLogs.forEach((row) => {
      const val = getRebootCellValue(row, key);
      if (val && val !== '-' && val !== '—') unique.add(String(val));
    });
    return Array.from(unique).sort((a, b) => a.localeCompare(b, 'ru'));
  }, [modemRebootLogs]);

  const handleFilterApply = useCallback((column, values) => {
    setActiveFilters((prev) => ({ ...prev, [column]: values.length > 0 ? values : undefined }));
    setCurrentPage(1);
  }, []);

  const handleFilterReset = useCallback((column) => {
    setActiveFilters((prev) => {
      const next = { ...prev };
      delete next[column];
      return next;
    });
    setCurrentPage(1);
  }, []);

  const handleRebootFilterApply = useCallback((column, values) => {
    setRebootActiveFilters((previousFilters) => ({
      ...previousFilters,
      [column]: values.length > 0 ? values : undefined,
    }));
    setRebootCurrentPage(1);
  }, []);

  const handleRebootFilterReset = useCallback((column) => {
    setRebootActiveFilters((previousFilters) => {
      const nextFilters = { ...previousFilters };
      delete nextFilters[column];
      return nextFilters;
    });
    setRebootCurrentPage(1);
  }, []);

  /* ========== SORTED + FILTERED + PAGINATED DATA ========== */
  const sortedData = useMemo(() => {
    const arr = [...detailedReplacementLogs];
    if (!sortKey) return arr;
    arr.sort((a, b) => {
      const va = getSortValue(a, sortKey);
      const vb = getSortValue(b, sortKey);
      if (typeof va === 'number' && typeof vb === 'number') return sortDir === 'asc' ? va - vb : vb - va;
      if (typeof va === 'string' && typeof vb === 'string') return sortDir === 'asc' ? va.localeCompare(vb, 'ru') : vb.localeCompare(va, 'ru');
      return 0;
    });
    return arr;
  }, [detailedReplacementLogs, sortKey, sortDir]);

  const filteredData = useMemo(() => {
    const filterKeys = Object.keys(activeFilters).filter((k) => activeFilters[k] && activeFilters[k].length > 0);
    if (filterKeys.length === 0) return sortedData;
    return sortedData.filter((row) =>
      filterKeys.every((key) => {
        const val = String(getCellValue(row, key));
        return activeFilters[key].includes(val);
      })
    );
  }, [sortedData, activeFilters]);

  const totalItems = filteredData.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / perPage));

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * perPage;
    return filteredData.slice(start, start + perPage);
  }, [filteredData, currentPage, perPage]);

  const rebootSortedData = useMemo(() => {
    const arr = [...modemRebootLogs];
    if (!rebootSortKey) return arr;
    arr.sort((a, b) => {
      const va = getRebootSortValue(a, rebootSortKey);
      const vb = getRebootSortValue(b, rebootSortKey);
      if (typeof va === 'number' && typeof vb === 'number') return rebootSortDir === 'asc' ? va - vb : vb - va;
      if (typeof va === 'string' && typeof vb === 'string') return rebootSortDir === 'asc' ? va.localeCompare(vb, 'ru') : vb.localeCompare(va, 'ru');
      return 0;
    });
    return arr;
  }, [modemRebootLogs, rebootSortKey, rebootSortDir]);

  const rebootFilteredData = useMemo(() => {
    const filterKeys = Object.keys(rebootActiveFilters).filter(
      (key) => rebootActiveFilters[key] && rebootActiveFilters[key].length > 0
    );
    if (filterKeys.length === 0) return rebootSortedData;
    return rebootSortedData.filter((row) =>
      filterKeys.every((key) => {
        const val = String(getRebootCellValue(row, key));
        return rebootActiveFilters[key].includes(val);
      })
    );
  }, [rebootSortedData, rebootActiveFilters]);

  const rebootTotalItems = rebootFilteredData.length;
  const rebootTotalPages = Math.max(1, Math.ceil(rebootTotalItems / perPage));
  const rebootPaginatedData = useMemo(() => {
    const start = (rebootCurrentPage - 1) * perPage;
    return rebootFilteredData.slice(start, start + perPage);
  }, [rebootFilteredData, rebootCurrentPage, perPage]);
  const rebootRangeStart = rebootTotalItems === 0 ? 0 : (rebootCurrentPage - 1) * perPage + 1;
  const rebootRangeEnd = Math.min(rebootCurrentPage * perPage, rebootTotalItems);

  const rangeStart = totalItems === 0 ? 0 : (currentPage - 1) * perPage + 1;
  const rangeEnd = Math.min(currentPage * perPage, totalItems);

  const handlePerPageChange = useCallback((val) => {
    setPerPage(Number(val));
    setCurrentPage(1);
    setRebootCurrentPage(1);
  }, []);

  const renderPckPagination = (
    start,
    end,
    total,
    pages,
    page = currentPage,
    setPage = setCurrentPage,
  ) => (
    <div className="pck-pagination">
      <p className="pck-pagination__info">
        <span className="pck-pagination__range">{start}-{end}</span>
        <span className="pck-pagination__text"> из </span>
        <span className="pck-pagination__total">{total}</span>
        <span className="pck-pagination__text"> записей</span>
      </p>

      <div className="pck-pagination__pages">
        <button
          type="button"
          className="pck-pagination__page-btn"
          disabled={page <= 1}
          onClick={() => setPage(1)}
          aria-label="Первая страница"
          tabIndex={0}
        >
          <ChevronFirstIcon />
        </button>
        <button
          type="button"
          className="pck-pagination__page-btn"
          disabled={page <= 1}
          onClick={() => setPage((previousPage) => previousPage - 1)}
          aria-label="Предыдущая страница"
          tabIndex={0}
        >
          <ChevronLeftIcon />
        </button>
        <div className="pck-pagination__current">{page}</div>
        <button
          type="button"
          className="pck-pagination__page-btn"
          disabled={page >= pages}
          onClick={() => setPage((previousPage) => previousPage + 1)}
          aria-label="Следующая страница"
          tabIndex={0}
        >
          <ChevronRightIcon />
        </button>
        <button
          type="button"
          className="pck-pagination__page-btn"
          disabled={page >= pages}
          onClick={() => setPage(pages)}
          aria-label="Последняя страница"
          tabIndex={0}
        >
          <ChevronLastIcon />
        </button>
      </div>

      <PerPageDropdown
        value={perPage}
        options={PER_PAGE_OPTIONS}
        onChange={handlePerPageChange}
      />
    </div>
  );

  /* ========== RENDER HELPERS ========== */
  const renderCell = (row, col) => {
    const value = getCellValue(row, col.key);

    if (col.key === 'tariff' && value !== '-') {
      return <span className={`pck-badge ${getTariffBadgeClass(value)}`}>{value}</span>;
    }

    if (col.key === 'status' && value !== '-') {
      return <span className={`pck-badge ${getStatusBadgeClass(value)}`}>{getStatusLabel(value)}</span>;
    }

    if (col.key === 'error') {
      const shouldShow = row?.status === 'failed' ||
        row?.details?.modem_params?.error ||
        row?.details?.modem_params?.new_modem?.error ||
        row?.details?.modem_params?.old_modem?.error;
      if (!shouldShow) return '-';
      return value !== '-' ? (
        <Tooltip title={value}>
          <span className="pck-badge pck-badge--red pck-cell-text">{value}</span>
        </Tooltip>
      ) : '-';
    }

    if (col.key === 'reason' && value.length > 40) {
      return (
        <Tooltip title={value}>
          <span className="pck-cell-text" title={value}>{value}</span>
        </Tooltip>
      );
    }

    return <span className="pck-cell-text" title={String(value)}>{value}</span>;
  };

  const renderRebootCell = (row, col) => {
    const value = getRebootCellValue(row, col.key);
    if (col.key === 'status' && value !== '-') {
      return <span className={`pck-badge ${getRebootStatusBadgeClass(value)}`}>{value}</span>;
    }
    if (col.key === 'guard_reason' && value !== '-') {
      return (
        <Tooltip title={value}>
          <span className="pck-cell-text" title={value}>{value}</span>
        </Tooltip>
      );
    }
    return <span className="pck-cell-text" title={String(value)}>{value}</span>;
  };

  /* ========== RENDER: TAB CONTENT ========== */
  /** Очередь ручной проверки / замер скорости — основной экран раздела «Проверка прокси» (/proxy-checker). */
  const renderManualCheck = () => (
    <>
      <AdminProxySpeedTestModal
        row={speedTestModalRow}
        onClose={() => {
          if (speedTestModalRow) {
            clearSpeedMeasureUiForQueueKey(adminQueueRowKey(speedTestModalRow));
          }
          setSpeedTestModalRow(null);
        }}
        onComplete={handleAdminSpeedTestComplete}
        onProbeProgress={(ui) => {
          if (speedTestModalRow) {
            updateSpeedMeasureUiForQueueKey(adminQueueRowKey(speedTestModalRow), ui);
          }
        }}
      />
      <CabinetManualCheckerQueueShell
        rows={cabinetQueueFilteredRows}
        onRunCheck={handleAdminCheckerQueueMassCheck}
        checking={checkerQueueChecking}
        onClear={handleClearAdminCheckerQueue}
        onMeasureSpeed={handleAdminQueueOpenSpeedTest}
        measuringSpeedIds={speedMeasureBusyIds}
        onCheckAvailability={handleAdminQueueAvailCheck}
        checkingAvailIds={availCheckBusyIds}
        onAppendCheckerProxies={handleAppendCheckerProxiesFromDraft}
        selectedKeys={adminCheckerSelectedKeys}
        onToggleRowSelected={handleToggleAdminCheckerRowSelected}
        onToggleAllSelected={handleToggleAdminCheckerSelectAll}
        onMassMeasureSpeed={handleMassAdminCheckerSpeed}
        massSpeedRunning={massSpeedSnap.massSpeedRunning}
        speedMeasureUiByQueueKey={mergedSpeedMeasureUiByQueueKey}
        resolveSupplierLabel={resolveCheckerSupplierLabel}
        resolveOperatorLabel={resolveCheckerOperatorLabel}
        queueFilters={cabinetQueueFiltersApi}
      />
    </>
  );

  /** Детальные логи автозамены — только встроенный блок в Настройках → «Логи автозамены». */
  const renderDetailedLogs = () => {
    if (loadingDetailedLogs || loading) {
      return (
        <DetailedLogsTableShell
          onAppendCheckerProxies={handleAppendCheckerProxiesFromDraft}
          showCheckerSidePanel={!embedded}
          tbodyContent={(
            <tr>
              <td colSpan={COLUMNS.length} className="pck-td--detailed-logs-placeholder">
                <div className="pck-loading pck-loading--in-table">
                  <div className="pck-loading__spinner" />
                  Загрузка данных…
                </div>
              </td>
            </tr>
          )}
        />
      );
    }

    if (detailedReplacementLogs.length === 0) {
      return (
        <CabinetDetailedLogsEmptyShell
          onAppendCheckerProxies={handleAppendCheckerProxiesFromDraft}
          showCheckerSidePanel={!embedded}
        />
      );
    }

    return (
      <div className="pck-cabinet-shell">
        <div className="proxy-checker">
          <div className="proxy-checker__row">
            <div className="proxy-checker__table-column">
              <div className="proxy-checker__table-card">
                <div className="proxy-checker__grid-wrap">
        <div className="pck-table-wrap">
          <table className="pck-table">
            <thead>
              <tr>
                {COLUMNS.map(col => {
                  const hasFilter = activeFilters[col.key] && activeFilters[col.key].length > 0;
                  return (
                    <th key={col.key} className={col.cssClass}>
                      <div className="pck-th-inner">
                        <span>{col.label}</span>
                        {col.sortable && (
                          <button
                            type="button"
                            className={`pck-th-sort ${sortKey === col.key ? 'pck-th-sort--active' : ''}`}
                            onClick={() => handleSort(col.key)}
                            aria-label={`Сортировать по ${col.label}`}
                            tabIndex={0}
                          >
                            {sortKey === col.key && sortDir === 'asc' ? <CaretUpIcon /> : <CaretDownIcon />}
                          </button>
                        )}
                        {col.filterable && (
                          <PckFilterBtn
                            colKey={col.key}
                            label={col.label}
                            hasFilter={hasFilter}
                            isOpen={openFilter === col.key}
                            onToggle={() => setOpenFilter(openFilter === col.key ? null : col.key)}
                            values={getColumnValues(col.key)}
                            activeFilters={activeFilters[col.key] || []}
                            onApply={handleFilterApply}
                            onReset={handleFilterReset}
                            onClose={() => setOpenFilter(null)}
                          />
                        )}
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {paginatedData.map(row => (
                <tr key={row.id}>
                  {COLUMNS.map(col => (
                    <td key={col.key} className={col.cssClass}>
                      {renderCell(row, col)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
                </div>

                <div className="pck-cabinet-shell__pagination">
                  {renderPckPagination(rangeStart, rangeEnd, totalItems, totalPages)}
                </div>
              </div>
            </div>
            {!embedded ? (
              <CabinetProxyCheckerSidePanel onAppendCheckerProxies={handleAppendCheckerProxiesFromDraft} />
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  const renderRebootLogs = () => {
    if (loadingModemRebootLogs || loading) {
      return (
        <div className="pck-loading pck-loading--in-table">
          <div className="pck-loading__spinner" />
          Загрузка логов перезагрузки…
        </div>
      );
    }

    if (modemRebootLogs.length === 0) {
      return (
        <div className="pck-td--detailed-logs-placeholder">
          Нет записей о перезагрузках за последние 7 дней
        </div>
      );
    }

    return (
      <div className="proxy-checker">
        <div className="proxy-checker__table-card">
          <div className="proxy-checker__grid-wrap">
            <div className="pck-table-wrap">
              <table className="pck-table pck-table--reboot-logs">
                <thead>
                  <tr>
                    {REBOOT_LOG_COLUMNS.map((col) => {
                      const hasFilter = rebootActiveFilters[col.key] && rebootActiveFilters[col.key].length > 0;
                      return (
                        <th key={col.key} className={col.cssClass}>
                          <div className="pck-th-inner">
                            <span>{col.label}</span>
                            {col.sortable && (
                              <button
                                type="button"
                                className={`pck-th-sort ${rebootSortKey === col.key ? 'pck-th-sort--active' : ''}`}
                                onClick={() => handleRebootSort(col.key)}
                                aria-label={`Сортировать по ${col.label}`}
                                tabIndex={0}
                              >
                                {rebootSortKey === col.key && rebootSortDir === 'asc' ? <CaretUpIcon /> : <CaretDownIcon />}
                              </button>
                            )}
                            {col.filterable && (
                              <PckFilterBtn
                                colKey={col.key}
                                label={col.label}
                                hasFilter={hasFilter}
                                isOpen={rebootOpenFilter === col.key}
                                onToggle={() => setRebootOpenFilter(rebootOpenFilter === col.key ? null : col.key)}
                                values={getRebootColumnValues(col.key)}
                                activeFilters={rebootActiveFilters[col.key] || []}
                                onApply={handleRebootFilterApply}
                                onReset={handleRebootFilterReset}
                                onClose={() => setRebootOpenFilter(null)}
                              />
                            )}
                          </div>
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {rebootPaginatedData.map((row) => (
                    <tr key={row.id}>
                      {REBOOT_LOG_COLUMNS.map((col) => (
                        <td key={col.key} className={col.cssClass}>
                          {renderRebootCell(row, col)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {renderPckPagination(
            rebootRangeStart,
            rebootRangeEnd,
            rebootTotalItems,
            rebootTotalPages,
            rebootCurrentPage,
            setRebootCurrentPage,
          )}
        </div>
      </div>
    );
  };

  /* ========== RULES: helper to get connection display name ========== */
  const getRuleTargetLabel = useCallback((rule) => (
    rule?.rule_target === 'foreign' ? 'Чужие прокси' : 'Свои прокси'
  ), []);

  const getRuleServerName = useCallback((rule) => {
    if (rule?.rule_target === 'foreign') return 'Чужие прокси';
    if (rule.apply_to_all_connections) return 'Все серверы';
    const ids = rule.kraken_connection_ids || [];
    if (ids.length === 0) return 'Все серверы';
    const names = ids.map(id => {
      const conn = krakenConnections.find(c => c.id === id);
      return conn ? (conn.display_name || conn.name) : `#${id}`;
    });
    if (names.length <= 2) return names.join(', ');
    return `${names[0]} +${names.length - 1}`;
  }, [krakenConnections]);

  const rulesServerValues = useMemo(() => {
    const set = new Set();
    (checkRules || []).forEach(rule => set.add(getRuleServerName(rule)));
    return [...set].sort();
  }, [checkRules, getRuleServerName]);

  const filteredCheckRules = useMemo(() => {
    if (rulesServerFilter.length === 0) return checkRules;
    return checkRules.filter(rule => rulesServerFilter.includes(getRuleServerName(rule)));
  }, [checkRules, rulesServerFilter, getRuleServerName]);

  const renderRules = () => {
    if (loading) {
      return <div className="pck-loading"><div className="pck-loading__spinner" />Загрузка…</div>;
    }

    return (
      <div className="pck-table-wrap">
        <table className="pck-table pck-rules-table">
          <thead>
            <tr>
              <th className="pck-rcol--status">
                <div className="pck-th-inner"><StatusDotHeader /></div>
              </th>
              <th className="pck-rcol--name">
                <div className="pck-th-inner"><span>Название</span></div>
              </th>
              <th className="pck-rcol--server">
                <div className="pck-th-inner">
                  <span>Сервер</span>
                  <PckFilterBtn
                    colKey="server"
                    label="Сервер"
                    hasFilter={rulesServerFilter.length > 0}
                    isOpen={rulesServerFilterOpen}
                    onToggle={() => setRulesServerFilterOpen(v => !v)}
                    values={rulesServerValues}
                    activeFilters={rulesServerFilter}
                    onApply={(col, vals) => { setRulesServerFilter(vals); setRulesServerFilterOpen(false); }}
                    onReset={() => { setRulesServerFilter([]); setRulesServerFilterOpen(false); }}
                    onClose={() => setRulesServerFilterOpen(false)}
                  />
                </div>
              </th>
              <th className="pck-rcol--autoreplace">
                <div className="pck-th-inner"><span>Автозамена</span></div>
              </th>
              <th className="pck-rcol--interval">
                <div className="pck-th-inner"><span>Интервал (мин)</span></div>
              </th>
              <th className="pck-rcol--autoreplace">
                <div className="pck-th-inner"><span>Reboot</span></div>
              </th>
              <th className="pck-rcol--interval">
                <div className="pck-th-inner"><span>1-й reboot</span></div>
              </th>
              <th className="pck-rcol--interval">
                <div className="pck-th-inner"><span>2-й reboot</span></div>
              </th>
              <th className="pck-rcol--tg-notify">
                <div className="pck-th-inner"><span>Уведомление ТГ</span></div>
              </th>
              <th className="pck-rcol--retries">
                <div className="pck-th-inner"><span>Кол-во попыток</span></div>
              </th>
              <th className="pck-rcol--replacements">
                <div className="pck-th-inner"><span>Кол-во неудач</span></div>
              </th>
              <th className="pck-rcol--actions">
                <div className="pck-th-inner"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredCheckRules.length === 0 ? (
              <tr>
                <td colSpan={12} style={{ textAlign: 'center', padding: 32, color: '#7a7a7a' }}>{checkRules.length === 0 ? 'Правил нет' : 'Нет совпадений'}</td>
              </tr>
            ) : filteredCheckRules.map(rule => (
              <tr key={rule.id}>
                <td className="pck-rcol--status">
                  <span className={`pck-status-dot ${rule.is_active ? 'pck-status-dot--green' : 'pck-status-dot--red'}`} />
                </td>
                <td className="pck-rcol--name">
                  <div className="pck-rule-name-cell">
                    <span className="pck-cell-text" title={rule.name}>{rule.name}</span>
                    <span className={`pck-rules-badge ${rule.rule_target === 'foreign' ? 'pck-rules-badge--foreign' : 'pck-rules-badge--own'}`}>
                      {getRuleTargetLabel(rule)}
                    </span>
                  </div>
                </td>
                <td className="pck-rcol--server">
                  <span className="pck-cell-text" title={getRuleServerName(rule)}>
                    {getRuleServerName(rule)}
                  </span>
                </td>
                <td className="pck-rcol--autoreplace">
                  <span className={`pck-rules-badge ${rule.auto_replace_enabled ? 'pck-rules-badge--on' : 'pck-rules-badge--off'}`}>
                    {rule.auto_replace_enabled ? 'Вкл' : 'Выкл'}
                  </span>
                </td>
                <td className="pck-rcol--interval">
                  <span className="pck-cell-text pck-cell-text--interval">
                    {rule.quick_availability_interval ?? 15}
                  </span>
                </td>
                <td className="pck-rcol--autoreplace">
                  <span className={`pck-rules-badge ${rule.modem_reboot_enabled ? 'pck-rules-badge--on' : 'pck-rules-badge--off'}`}>
                    {rule.modem_reboot_enabled ? 'Вкл' : 'Выкл'}
                  </span>
                </td>
                <td className="pck-rcol--interval">
                  <span className="pck-cell-text pck-cell-text--interval">
                    {rule.modem_reboot_first_delay_minutes ?? 15}
                  </span>
                </td>
                <td className="pck-rcol--interval">
                  <span className="pck-cell-text pck-cell-text--interval">
                    {rule.modem_reboot_second_delay_minutes ?? 30}
                  </span>
                </td>
                <td className="pck-rcol--tg-notify">
                  <span className="pck-cell-text pck-cell-text--interval">
                    {rule.down_notification_interval_minutes ?? 15}
                  </span>
                </td>
                <td className="pck-rcol--retries">
                  <span>{rule.retry_attempts ?? 3}</span>
                </td>
                <td className="pck-rcol--replacements">
                  <span>{rule.replacement_attempts ?? 3}</span>
                </td>
                <td className="pck-rcol--actions">
                  <RulesActionMenu
                    rule={rule}
                    onEdit={handleEditRule}
                    onToggle={handleToggleRuleStatus}
                    onDelete={handleDeleteRule}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  /* ========== MAIN RENDER ========== */
  return (
    <div className={`pck-page pm-content-fade-in${embedded ? ' pck-page--embedded-settings' : ''}`}>
      {/* ---- Header ---- */}
      <div className={`pck-header${embedded ? ' pck-header--embedded' : ''}`}>
        {!embedded && <h1 className="pck-header__title">Проверка прокси</h1>}

        {showPageHeaderTabs && (
          <div className="pck-header__tabs">
            {STANDALONE_PROXY_CHECKER_TABS.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={`pck-header__tab ${activeTabKey === tab.key ? 'pck-header__tab--active' : ''}`}
                onClick={() => setActiveTabKey(tab.key)}
                tabIndex={0}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}

        {!embedded && !showPageHeaderTabs && <div className="pck-header__spacer" aria-hidden="true" />}

        <div className="pck-header__actions">
          {activeFilterCount > 0 && (
            <button
              type="button"
              className="pck-header__btn pck-header__btn--clear-filters"
              onClick={handleClearAllFilters}
              aria-label={`Сбросить фильтры (${activeFilterCount})`}
              tabIndex={0}
              title={`Сбросить фильтры (${activeFilterCount})`}
            >
              <FilterOffIcon />
            </button>
          )}
          <button
            className="pck-header__btn"
            onClick={() => {
              loadStatusData();
              if (activeTabKey === 'detailed-replacement-logs') {
                loadDetailedReplacementLogs();
              } else {
                loadData();
              }
              if (activeTabKey === 'manual-check') {
                ensureAdminCheckerQueueLoaded().then((rows) => {
                  setAdminCheckerQueue(Array.isArray(rows) ? rows : readAdminCheckerQueue());
                });
              }
            }}
            aria-label="Обновить"
            tabIndex={0}
            title="Обновить"
          >
            <RefreshIcon />
          </button>
          <button
            className={`pck-header__btn pck-header__btn--check-all${checkingAll ? ' pck-header__btn--checking' : ''}`}
            onClick={handleRunCheckAll}
            disabled={checkingAll}
            aria-label="Проверить все прокси"
            tabIndex={0}
            data-tooltip="Проверка прокси"
          >
            <RecycleIcon />
          </button>
          <button
            className={`pck-header__btn${statsVisible ? ' pck-header__btn--active' : ''}`}
            onClick={handleStatsToggle}
            aria-label="Статистика"
            tabIndex={0}
            title="Статистика"
          >
            <GridIcon />
          </button>
          {activeTabKey === 'rules' && (
            <div className="pck-create-rule-menu-wrap">
              <button
                ref={createRuleBtnRef}
                className="pck-header__btn pck-header__btn--primary"
                onClick={() => setCreateRuleMenuOpen((prev) => !prev)}
                aria-label="Создать правило"
                aria-expanded={createRuleMenuOpen}
                tabIndex={0}
                title="Создать правило"
              >
                <PlusIcon />
              </button>
              {createRuleMenuOpen && (
                <div
                  ref={createRuleMenuRef}
                  className="pck-create-rule-menu pm-action-dropdown--anchored"
                  role="menu"
                  aria-label="Тип правила"
                >
                  <button
                    type="button"
                    className="pm-action-dropdown--portal__item"
                    role="menuitem"
                    onClick={() => handleOpenRuleModalForTarget('own')}
                  >
                    Правило для своих
                  </button>
                  <button
                    type="button"
                    className="pm-action-dropdown--portal__item"
                    role="menuitem"
                    onClick={() => handleOpenRuleModalForTarget('foreign')}
                  >
                    Правило для чужих
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* ---- Content ---- */}
      <div className={`pck-content${statsVisible ? ' pck-content--with-stats' : ''}`}>
        <div className="pck-content__main">
          {activeTabKey === 'manual-check' && renderManualCheck()}
          {activeTabKey === 'detailed-replacement-logs' && renderDetailedLogs()}
          {activeTabKey === 'modem-reboot-logs' && renderRebootLogs()}
          {activeTabKey === 'rules' && renderRules()}
        </div>
        {statsVisible && (
          <ProxyStatsPanel statusData={statusData} loading={statusLoading} onClose={handleStatsToggle} />
        )}
      </div>

      {/* ---- Rule Side Panel ---- */}
      {ruleModalVisible && typeof document !== 'undefined' && ReactDOM.createPortal(
        <div className="pck-rule-panel-overlay" {...ruleBackdrop}>
          <div className="pck-rule-panel" onClick={(e) => e.stopPropagation()}>
            {/* Panel Header */}
            <div className="pck-rule-panel__header">
              <span className="pck-rule-panel__title">
                {editingRule
                  ? `Редактировать правило: ${getRuleTargetLabel(editingRule)}`
                  : `Создать правило: ${ruleDraftTarget === 'foreign' ? 'Чужие прокси' : 'Свои прокси'}`}
              </span>
              <button
                type="button"
                className="pck-rule-panel__close"
                onClick={handleCloseRuleModal}
                aria-label="Закрыть"
                tabIndex={0}
              >
                <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </button>
            </div>

            {/* Panel Body */}
            <div className="pck-rule-panel__body">
              <Form form={form} layout="vertical" onFinish={handleCreateRule} className="pck-rule-form">
                <Form.Item name="rule_target" hidden initialValue={ruleDraftTarget}>
                  <Input />
                </Form.Item>

                {/* Row 1: Name + Interval */}
                <div className="pck-rule-form__row">
                  <div className="pck-rule-form__field">
                    <div className="pck-rule-form__label">
                      <span className="pck-rule-form__label-required">*</span>
                      <span>Название правила</span>
                    </div>
                    <Form.Item name="name" rules={[{ required: true, message: 'Введите название' }]}>
                      <Input placeholder="Например: Ежедневная проверка" className="pck-rule-form__input" />
                    </Form.Item>
                  </div>

                  <div className="pck-rule-form__field">
                    <div className="pck-rule-form__label">
                      <span className="pck-rule-form__label-required">*</span>
                      <span>Интервал проверки доступности (мин)</span>
                    </div>
                    <Form.Item name="quick_availability_interval" rules={[{ required: true, message: 'Введите интервал' }]} initialValue={15}>
                      <InputNumber min={1} max={1440} className="pck-rule-form__input-number" />
                    </Form.Item>
                  </div>
                </div>

                <div className="pck-rule-form__row">
                  <div className="pck-rule-form__field">
                    <div className="pck-rule-form__label">
                      <span className="pck-rule-form__label-required">*</span>
                      <span>Уведомления телеграм</span>
                    </div>
                    <Form.Item
                      name="down_notification_interval_minutes"
                      rules={[{ required: true, message: 'Введите интервал уведомления' }]}
                      initialValue={15}
                    >
                      <InputNumber min={1} max={10080} className="pck-rule-form__input-number" />
                    </Form.Item>
                  </div>
                  <div className="pck-rule-form__field">
                    <div className="pck-rule-form__label">
                      <span>Тип правила</span>
                    </div>
                    <div className="pck-rule-form__rule-type">
                      {ruleDraftTarget === 'foreign' ? 'Чужие прокси' : 'Свои прокси'}
                    </div>
                  </div>
                </div>

                <div className="pck-rule-form__row">
                  <div className="pck-rule-form__field">
                    <div className="pck-rule-form__label">
                      <span className="pck-rule-form__label-required">*</span>
                      <span>1-я перезагрузка (мин)</span>
                    </div>
                    <Form.Item
                      name="modem_reboot_first_delay_minutes"
                      rules={[{ required: true, message: 'Введите время первой перезагрузки' }]}
                      initialValue={15}
                    >
                      <InputNumber min={1} max={10080} className="pck-rule-form__input-number" />
                    </Form.Item>
                  </div>
                  <div className="pck-rule-form__field">
                    <div className="pck-rule-form__label">
                      <span className="pck-rule-form__label-required">*</span>
                      <span>2-я перезагрузка (мин)</span>
                    </div>
                    <Form.Item
                      name="modem_reboot_second_delay_minutes"
                      rules={[{ required: true, message: 'Введите время второй перезагрузки' }]}
                      initialValue={30}
                    >
                      <InputNumber min={1} max={10080} className="pck-rule-form__input-number" />
                    </Form.Item>
                  </div>
                </div>

                <Form.Item noStyle shouldUpdate={(prev, cur) => prev?.rule_target !== cur?.rule_target}>
                  {({ getFieldValue }) => {
                    const isForeignTarget = getFieldValue('rule_target') === 'foreign';
                    if (isForeignTarget) {
                      return null;
                    }
                    return (
                      <div className="pck-rule-form__field pck-rule-form__field--full">
                        <div className="pck-rule-form__label">
                          <span>URL для проверки доступности</span>
                          <Tooltip title="Каждый URL с новой строки. Используется для быстрой проверки доступности прокси">
                            <span className="pck-rule-form__info-icon" tabIndex={0} aria-label="Подсказка">
                              <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                                <path d="M6 5.5V8.5" stroke="currentColor" strokeLinecap="round"/>
                                <circle cx="6" cy="4" r="0.5" fill="currentColor"/>
                              </svg>
                            </span>
                          </Tooltip>
                        </div>
                        <Form.Item
                          name="quick_availability_urls"
                          initialValue={['https://laminat98.ru/ip.php', 'https://polteplov.ru/ip.php'].join('\n')}
                        >
                          <Input.TextArea
                            rows={4}
                            placeholder={"https://laminat98.ru/ip.php\nhttps://polteplov.ru/ip.php"}
                            className="pck-rule-form__textarea"
                          />
                        </Form.Item>
                      </div>
                    );
                  }}
                </Form.Item>

                {/* Row 3: Description textarea */}
                <div className="pck-rule-form__field pck-rule-form__field--full">
                  <div className="pck-rule-form__label">
                    <span>Описание правила</span>
                  </div>
                  <Form.Item name="description">
                    <Input.TextArea
                      rows={4}
                      placeholder="Описание правила"
                      className="pck-rule-form__textarea"
                    />
                  </Form.Item>
                </div>

                {/* Row 4: Retry attempts + Replacement attempts (только свои) */}
                <Form.Item noStyle shouldUpdate={(prev, cur) => prev?.rule_target !== cur?.rule_target}>
                  {({ getFieldValue }) => {
                    const isForeignTarget = getFieldValue('rule_target') === 'foreign';
                    if (isForeignTarget) {
                      return null;
                    }
                    return (
                <div className="pck-rule-form__row">
                  <div className="pck-rule-form__field">
                    <div className="pck-rule-form__label">
                      <span>Кол-во попыток</span>
                      <Tooltip title="Количество попыток проверки прокси перед признанием его недоступным">
                        <span className="pck-rule-form__info-icon" tabIndex={0} aria-label="Подсказка">
                          <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                            <path d="M6 5.5V8.5" stroke="currentColor" strokeLinecap="round"/>
                            <circle cx="6" cy="4" r="0.5" fill="currentColor"/>
                          </svg>
                        </span>
                      </Tooltip>
                    </div>
                    <Form.Item name="retry_attempts" initialValue={3}>
                      <InputNumber min={1} max={10} className="pck-rule-form__input-number" />
                    </Form.Item>
                  </div>

                  <div className="pck-rule-form__field">
                    <div className="pck-rule-form__label">
                      <span>Замена после неудач</span>
                      <Tooltip title="Количество попыток автозамены модема при неудачной проверке">
                        <span className="pck-rule-form__info-icon" tabIndex={0} aria-label="Подсказка">
                          <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                            <path d="M6 5.5V8.5" stroke="currentColor" strokeLinecap="round"/>
                            <circle cx="6" cy="4" r="0.5" fill="currentColor"/>
                          </svg>
                        </span>
                      </Tooltip>
                    </div>
                    <Form.Item name="replacement_attempts" initialValue={3}>
                      <InputNumber min={1} max={10} className="pck-rule-form__input-number" />
                    </Form.Item>
                  </div>
                </div>
                    );
                  }}
                </Form.Item>

                {/* Row 5: Max parallel + Retry delay */}
                <div className="pck-rule-form__row">
                  <div className="pck-rule-form__field">
                    <div className="pck-rule-form__label">
                      <span className="pck-rule-form__label-required">*</span>
                      <span>Макс. параллельных проверок</span>
                      <Tooltip title="Максимальное количество прокси, проверяемых одновременно">
                        <span className="pck-rule-form__info-icon" tabIndex={0} aria-label="Подсказка">
                          <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                            <path d="M6 5.5V8.5" stroke="currentColor" strokeLinecap="round"/>
                            <circle cx="6" cy="4" r="0.5" fill="currentColor"/>
                          </svg>
                        </span>
                      </Tooltip>
                    </div>
                    <Form.Item name="max_parallel_checks" rules={[{ required: true, message: 'Обязательное поле' }]} initialValue={10}>
                      <InputNumber min={1} max={100} className="pck-rule-form__input-number" />
                    </Form.Item>
                  </div>

                  <Form.Item noStyle shouldUpdate={(prev, cur) => prev?.rule_target !== cur?.rule_target}>
                    {({ getFieldValue }) => {
                      const isForeignTarget = getFieldValue('rule_target') === 'foreign';
                      if (isForeignTarget) {
                        return null;
                      }
                      return (
                  <div className="pck-rule-form__field">
                    <div className="pck-rule-form__label">
                      <span>Задержка между попытками (сек)</span>
                      <Tooltip title="Задержка в секундах между повторными попытками проверки">
                        <span className="pck-rule-form__info-icon" tabIndex={0} aria-label="Подсказка">
                          <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                            <path d="M6 5.5V8.5" stroke="currentColor" strokeLinecap="round"/>
                            <circle cx="6" cy="4" r="0.5" fill="currentColor"/>
                          </svg>
                        </span>
                      </Tooltip>
                    </div>
                    <Form.Item name="retry_delay" initialValue={1}>
                      <InputNumber min={1} max={300} className="pck-rule-form__input-number" />
                    </Form.Item>
                  </div>
                      );
                    }}
                  </Form.Item>
                </div>

                {/* Toggles Section */}
                <div className="pck-rule-form__toggles">
                  {/* Toggle: Active */}
                  <div className="pck-rule-form__toggle-row">
                    <div className="pck-rule-form__toggle-label">
                      <span>Активно правило</span>
                      <Tooltip title="Включает или выключает правило проверки">
                        <span className="pck-rule-form__info-icon" tabIndex={0} aria-label="Подсказка">
                          <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                            <path d="M6 5.5V8.5" stroke="currentColor" strokeLinecap="round"/>
                            <circle cx="6" cy="4" r="0.5" fill="currentColor"/>
                          </svg>
                        </span>
                      </Tooltip>
                    </div>
                    <Form.Item name="is_active" valuePropName="checked" initialValue={true} noStyle>
                      <Switch className="pck-rule-form__switch" />
                    </Form.Item>
                  </div>

                  <Form.Item noStyle shouldUpdate={(prev, cur) => prev?.rule_target !== cur?.rule_target}>
                    {({ getFieldValue }) => {
                      const isForeignTarget = getFieldValue('rule_target') === 'foreign';
                      if (isForeignTarget) {
                        return null;
                      }
                      return (
                        <>
                          <div className="pck-rule-form__toggle-row">
                            <div className="pck-rule-form__toggle-label">
                              <span>Перезагрузка модемов</span>
                              <Tooltip title="Автоматически запускать reboot недоступного модема по таймингам правила">
                                <span className="pck-rule-form__info-icon" tabIndex={0} aria-label="Подсказка">
                                  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                                    <path d="M6 5.5V8.5" stroke="currentColor" strokeLinecap="round"/>
                                    <circle cx="6" cy="4" r="0.5" fill="currentColor"/>
                                  </svg>
                                </span>
                              </Tooltip>
                            </div>
                            <Form.Item name="modem_reboot_enabled" valuePropName="checked" initialValue={false} noStyle>
                              <Switch className="pck-rule-form__switch" />
                            </Form.Item>
                          </div>

                          <div className="pck-rule-form__toggle-row">
                            <div className="pck-rule-form__toggle-label">
                              <span>Автозамена при неудачной проверке</span>
                              <Tooltip title="Автоматически заменять модем при неудачной проверке прокси">
                                <span className="pck-rule-form__info-icon" tabIndex={0} aria-label="Подсказка">
                                  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                                    <path d="M6 5.5V8.5" stroke="currentColor" strokeLinecap="round"/>
                                    <circle cx="6" cy="4" r="0.5" fill="currentColor"/>
                                  </svg>
                                </span>
                              </Tooltip>
                            </div>
                            <Form.Item name="auto_replace_enabled" valuePropName="checked" initialValue={false} noStyle>
                              <Switch className="pck-rule-form__switch" />
                            </Form.Item>
                          </div>

                          <div className="pck-rule-form__toggle-row">
                            <div className="pck-rule-form__toggle-label">
                              <span>Применить ко всем подключениям</span>
                              <Tooltip title="Применить правило ко всем подключениям Kraken или только к выбранным">
                                <span className="pck-rule-form__info-icon" tabIndex={0} aria-label="Подсказка">
                                  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                                    <path d="M6 5.5V8.5" stroke="currentColor" strokeLinecap="round"/>
                                    <circle cx="6" cy="4" r="0.5" fill="currentColor"/>
                                  </svg>
                                </span>
                              </Tooltip>
                            </div>
                            <Form.Item name="apply_to_all_connections" valuePropName="checked" noStyle>
                              <Switch className="pck-rule-form__switch" />
                            </Form.Item>
                          </div>
                        </>
                      );
                    }}
                  </Form.Item>
                </div>

                {/* Kraken connections dropdown */}
                <Form.Item
                  noStyle
                  shouldUpdate={(prev, cur) => (
                    prev?.apply_to_all_connections !== cur?.apply_to_all_connections
                    || prev?.rule_target !== cur?.rule_target
                  )}
                >
                  {({ getFieldValue }) => {
                    const isForeignTarget = getFieldValue('rule_target') === 'foreign';
                    if (isForeignTarget) {
                      return null;
                    }
                    const applyToAll = getFieldValue('apply_to_all_connections') !== false;
                    return (
                      <div className="pck-rule-form__field pck-rule-form__field--full">
                        <div className="pck-rule-form__label">
                          <span>Подключения Kraken</span>
                          <Tooltip title="Выберите подключения Kraken, к которым применяется правило">
                            <span className="pck-rule-form__info-icon" tabIndex={0} aria-label="Подсказка">
                              <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                                <path d="M6 5.5V8.5" stroke="currentColor" strokeLinecap="round"/>
                                <circle cx="6" cy="4" r="0.5" fill="currentColor"/>
                              </svg>
                            </span>
                          </Tooltip>
                        </div>
                        <Form.Item name="kraken_connection_ids">
                          <Select
                            mode="multiple"
                            placeholder={applyToAll ? 'Ко всем подключениям' : 'Выберите подключения'}
                            disabled={applyToAll}
                            allowClear
                            className="pck-rule-form__select"
                            options={krakenConnections.map(c => ({
                              value: c.id,
                              label: `${c.display_name || c.name}${c.modems_count ? ` (${c.modems_count} модемов)` : ''}`,
                            }))}
                          />
                        </Form.Item>
                      </div>
                    );
                  }}
                </Form.Item>

              </Form>
            </div>

            {/* Panel Footer */}
            <div className="pck-rule-panel__footer">
              <button
                type="button"
                className="pck-rule-panel__btn pck-rule-panel__btn--cancel"
                onClick={handleCloseRuleModal}
                tabIndex={0}
              >
                Отмена
              </button>
              <button
                type="button"
                className="pck-rule-panel__btn pck-rule-panel__btn--save"
                onClick={() => form.submit()}
                tabIndex={0}
              >
                {editingRule ? 'Сохранить' : 'Создать'}
              </button>
            </div>
          </div>
        </div>,
        document.body,
      )}
    </div>
  );
};

export default ProxyChecker;
